import React, { useContext, useEffect, useRef, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import Select from "react-select";
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { currentDateAndTime, decodeData, decodeUrl,encodeData, genderOptions } from '../../Constants/constants';
import Swal from 'sweetalert2';
import { SubmitButton } from '../../Components/InputElements';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const PayrollHeadCreate = () => {
    // const { company_salary_head_id } = useParams();
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
    const query = useQuery();
    const navigate = useNavigate();
    const encodedData = query.get("abs");
    const decodedDataId = decodeUrl(encodedData);
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const company_salary_head_id = query.get("id");
    const title = query.get("title");
    const headType = query.get("type");
    const page = query.get("page");
    const limit = query.get("limit");
    
    const [rows, setRows] = useState([]);
    const [fixedHeadRows, setFixedHeadRows] = useState([]);
    const [leaveOptions, setLeaveOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        headTitle: "",
        is_editable: "",
        payrollHeadType: null,
        visibleHeadInPayslip: null,
        headTitleForPayslip: "",
        headAgeCriteria: null,
        checkEmployeeEligibility: null,
        checkEmployeeEligibilityValue: null,
        hasAnyFixedHead: null,
        hasAnyFixedHeadValue: null,
        isHeadForOtRate: null,
        isHeadForOtRateValue: "0",
        // isEsicHead: "0",
        headAgeNumber: null,
        calculateHead: null,
        payableOrLOPDays: null,
        payableOrLOPDaysHead: null,
        // payableDayHead: null,
        // presentDayHead: null,
        fixedRate: null,
        calculateOnSlabValue: null,
        slabHeads: null,
        slabHeadSub: null,
        sumOfHead: null,
        subOfHead: null,
        operator1: null,
        calculateOnFormulaComponentsValue1: "2",
        calculateOnFormulaComponentsValue2: "2",
        calculateOnFormulaComponentsValue3: "2",
        calculateOnFormulaComponentsValue4: "2",
        calculateOnFormulaComponentsValue5: "2",
        calculateOnFormulaComponentsValueHead1: null,
        calculateOnFormulaComponentsValueHead2: null,
        calculateOnFormulaComponentsValueHead3: null,
        calculateOnFormulaComponentsValueHead4: null,
        calculateOnFormulaComponentsValueHead5: null,
        inputValue1: null,
        operator2: null,
        inputValue2: null,
        operator3: null,
        inputValue3: null,
        operator4: null,
        inputValue4: null,
        operator5: null,
        inputValue5: null,
        calculationFrequency: null,
        monthlyFrequency: null,
        yearlyFrequency: null,
        halfYearlyFrequency: null,
        quarterlyFrequency: null,
        headValueToBe: null,
        monthlyGross: null,
        monthlyGrossType: null,
        eeStatutoryDeduction: null,
        eeStatutoryDeductionType: null,
        erStatutoryContribution: null,
        erStatutoryContributionType: null,
        monthlyOtherEarnings: null,
        monthlyOtherEarningsType: null,
        consideredArrearHead: null,
        isPartOfMonthlyCtc: null,
        isPartOfMonthlyCtcType: null,
        monthlyDeduction: null,
        monthlyDeductionType: null,
        isStatutory: null,
        isStatutoryType: null,
        isExGratia: null,
        isGratuity: null,
        effectOnNetPay: null,
        effectOnNetPayType: null,
        componentLeaveEncashment: null,
        leavesToBeEncashed: null,
        isMinCapping: null,
        isMinCappingInput: null,
        isMaxCapping: null,
        isMaxCappingInput: null,
        monthlySalaryRegister: null,
        monthlySalaryRegisterType: null,
        dependsOnIndividualEmployee: null,
        isCreateEarnedHead: null,

        // componentStateWiseCriteria: null,
    });
    const [slabRows, setSlabRows] = useState([
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
        {
            earnedSlabMin: null,
            earnedSlabMax: null,
            gender: null,
            employeeContribution: null,
            employerContribution: null,
            frequency: null,
            months: null,
            minCap: null,
            maxCap: null,
        },
    ]);
    const [slabOptions, setSlabOptions] = useState([]);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [employeeRows, setEmployeeRows] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: "",
        total_pages: "",
    });
    const [loadingList, setLoadingList] = useState(false);

    const statutorySlabOptions = [
        { value: "PT", label: "PT" },
        { value: "ER LWF", label: "ER LWF" },
        { value: "EE LWF", label: "EE LWF" },
    ];
    const headOptions = [
        { value: "Fixed Component", label: "Fixed Component" },
        { value: "Earning", label: "Earning" },
        { value: "EE Statutory Deduction", label: "EE Statutory Deduction" },
        { value: "ER Statutory Contribution", label: "ER Statutory Contribution" },
        { value: "Other Earnings", label: "Other Earnings" },
        { value: "Other Deductions", label: "Other Deductions" },
    ];
    const otOptions = [
        { value: "0", label: "0" },
        { value: "1", label: "1" },
        { value: "1.5", label: "1.5" },
        { value: "2", label: "2" },
    ];
    const eligibilityValue = [
        { value: "PF Applicable", label: "PF Applicable" },
        { value: "VPF Applicable", label: "VPF Applicable" },
        { value: "ESIC Applicable", label: "ESIC Applicable" },
        { value: "LWF Applicable", label: "LWF Applicable" },
        { value: "PT Applicable", label: "PT Applicable" },
        { value: "Bonus Applicable", label: "Bonus Applicable" },
        { value: "Gratuity Applicable", label: "Gratuity Applicable" },
        { value: "WC Applicable", label: "WC Applicable" },
        { value: "NPS Applicable", label: "NPS Applicable" },
    ];
    const frequencyOptions = [
        { value: "Monthly", label: "Monthly" },
        { value: "Yearly", label: "Yearly" },
        { value: "Half Year", label: "Half Year" },
        { value: "Quarterly", label: "Quarterly" },
    ];
    const operatorOptions = [
        { value: "%", label: "Percentage" },
        { value: "/", label: "Divide" },
        { value: "*", label: "Multiply" },
        { value: "+", label: "Add" },
        { value: "-", label: "Substract" },
    ];
    const headOrValueOptions = [
        { value: "1", label: "Head" },
        { value: "2", label: "Value" },
        { value: "3", label: "Month Days" },
        { value: "4", label: "Leave Days" },
    ];

    const monthDataOptions = [{ value: "All", label: "All" }, { value: "Jan", label: "Jan" }, { value: "Feb", label: "Feb" }, { value: "Mar", label: "Mar" }, { value: "Apr", label: "Apr" }, { value: "May", label: "May" }, { value: "Jun", label: "Jun" },
    { value: "Jul", label: "Jul" }, { value: "Aug", label: "Aug" }, { value: "Sep", label: "Sep" }, { value: "Oct", label: "Oct" }, { value: "Nov", label: "Nov" }, { value: "Dec", label: "Dec" }];
    const monthDataOptions2 = [{ value: "Jan", label: "Jan" }, { value: "Feb", label: "Feb" }, { value: "Mar", label: "Mar" }, { value: "Apr", label: "Apr" }, { value: "May", label: "May" }, { value: "Jun", label: "Jun" },
    { value: "Jul", label: "Jul" }, { value: "Aug", label: "Aug" }, { value: "Sep", label: "Sep" }, { value: "Oct", label: "Oct" }, { value: "Nov", label: "Nov" }, { value: "Dec", label: "Dec" }];


    const handleChange = (name, value) => {
        console.log(name, value);
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleMultiSelect = (fieldName, selectedOptions) => {

        if ((Array.isArray(selectedOptions) && selectedOptions?.find((val) => val?.value === "All")) || selectedOptions?.value === "All") {
            setFormData(prevFormData => ({
                ...prevFormData,
                [fieldName]: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec"
            }));
        }
        // else if (selectedOptions?.value === "yearlyFrequency") {
        //     if (formData?.yearlyFrequency) {

        //     }
        // }
        // else if (selectedOptions?.value === "halfYearlyFrequency") {

        // }
        // else if (selectedOptions?.value === "quarterlyFrequency") {

        // }
        else {
            // console.log("selectedOptions", selectedOptions);
        
            const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
            console.log('ids', fieldName, ids.join(','));
            // console.log('sumOfHead', formData?.sumOfHead);
            setFormData(prevFormData => ({
                ...prevFormData,
                [fieldName]: ids.join(',')
            }));

        }


        // Clear the error message for componentLocation
        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };

    const handleSlabChange = (index, fieldName, value) => {
        const updatedSlabRows = [...slabRows];
        updatedSlabRows[index] = {
            ...updatedSlabRows[index],
            [fieldName]: value,
        };
        setSlabRows(updatedSlabRows);
    };
    const handleSlabMultiSelect = (index, fieldName, selectedOptions) => {
        // Extract the selected month values or set an empty array if no options are selected
        const months = selectedOptions?.map(option => option.value) || [];

        // Create a shallow copy of slabRows to avoid directly mutating the state
        setSlabRows(prevSlabRows => prevSlabRows.map((row, rowIndex) =>
            rowIndex === index
                ? {
                    ...row,
                    [fieldName]: months.join(","), // Join the selected months as a comma-separated string
                }
                : row // Return the row as is if it is not the targeted index
        ));
    };


    const payrollHeadTypeRef = useRef(null);
    const headTitleRef = useRef(null);
    const headTitleForPayslipRef = useRef(null);
    const headAgeNumberRef = useRef(null);
    const checkEmployeeEligibilityRef = useRef(null);
    const checkEmployeeEligibilityValueRef = useRef(null);
    const hasAnyFixedHeadRef = useRef(null);
    const hasAnyFixedHeadValueRef = useRef(null);
    // const isEsicHeadRef = useRef(null);
    const isHeadForOtRateRef = useRef(null);
    const isHeadForOtRateValueRef = useRef(null);
    const headEligibilityValueRef = useRef(null);
    const visibleHeadInPayslipRef = useRef(null);
    const headAgeCriteriaRef = useRef(null);
    const headEligibilityRef = useRef(null);
    const calculateHeadRef = useRef(null);
    const payableOrLOPDaysRef = useRef(null);
    const payableOrLOPDaysHeadRef = useRef(null);
    const calculateOnSlabValueRef = useRef(null);
    const slabHeadsRef = useRef(null);
    const slabHeadSubRef = useRef(null);
    // const payableDayHeadRef = useRef(null);
    // const presentDayHeadRef = useRef(null);
    const fixedRateRef = useRef(null);
    const sumOfHeadRef = useRef(null);
    const subOfHeadRef = useRef(null);
    // const operator1Ref = useRef(null);
    // const inputValue1Ref = useRef(null);
    // const operator2Ref = useRef(null);
    // const inputValue2Ref = useRef(null);
    // const operator3Ref = useRef(null);
    // const inputValue3Ref = useRef(null);
    // const operator4Ref = useRef(null);
    // const inputValue4Ref = useRef(null);
    // const operator5Ref = useRef(null);
    // const inputValue5Ref = useRef(null);
    const calculationFrequencyRef = useRef(null);
    const monthlyFrequencyRef = useRef(null);
    const yearlyFrequencyRef = useRef(null);
    const halfYearlyFrequencyRef = useRef(null);
    const quarterlyFrequencyRef = useRef(null);
    const onboardingCtcRef = useRef(null);
    // const onboardingCtcTypeRef= useRef(null);
    const otherEarningsRef = useRef(null);
    // const otherEarningsInAttendanceRef = useRef(null);
    const headValueToBeRef= useRef(null);
    const monthlyGrossRef = useRef(null);
    const monthlyGrossTypeRef = useRef(null);
    const eeStatutoryDeductionRef = useRef(null);
    const eeStatutoryDeductionTypeRef = useRef(null);
    const erStatutoryContributionRef = useRef(null);
    const erStatutoryContributionTypeRef = useRef(null);
    const monthlyOtherEarningsRef = useRef(null);
    const monthlyOtherEarningsTypeRef = useRef(null);
    // const isPartOfMonthlyCtcRef = useRef(null);
    // const isPartOfMonthlyCtcTypeRef = useRef(null);
    const monthlyDeductionRef = useRef(null);
    const monthlyDeductionTypeRef = useRef(null);
    const isStatutoryRef = useRef(null);
    const isStatutoryTypeRef = useRef(null);
    const isExGratiaRef = useRef(null);
    const isGratuityRef = useRef(null);
    // const effectOnNetPayRef = useRef(null);
    // const effectOnNetPayTypeRef = useRef(null);
    const componentLeaveEncashmentRef = useRef(null);
    const leavesToBeEncashedRef = useRef(null);
    const isMinCappingRef = useRef(null);
    const isMinCappingInputRef = useRef(null);
    const isMaxCappingRef = useRef(null);
    const isMaxCappingInputRef = useRef(null);
    const isMaxCappingHeadSumRef = useRef(null);
    const isMaxCappingHeadSubRef = useRef(null);
    const monthlySalaryRegisterRef = useRef(null);
    const monthlySalaryRegisterTypeRef = useRef(null);
    const consideredArrearHeadRef = useRef(null);
    const dependsOnIndividualEmployeeRef = useRef(null);
    const isCreateEarnedHeadRef = useRef(null);
    // const componentStateWiseCriteriaRef = useRef(null);


    useEffect(() => {
        console.log("errors", errors);
        if (errors?.headTitle) {
            headTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            headTitleRef.current?.focus();
        }
        // if (errors?.isPartOfMonthlyCtc) {
        //     isPartOfMonthlyCtcRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     isPartOfMonthlyCtcRef.current?.focus();
        // }
        if (errors?.headTitleForPayslip) {
            headTitleForPayslipRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            headTitleForPayslipRef.current?.focus();
        }
        if (errors?.headAgeNumber) {
            headAgeNumberRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            headAgeNumberRef.current?.focus();
        }
        if (errors?.checkEmployeeEligibility) {
            checkEmployeeEligibilityRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            checkEmployeeEligibilityRef.current?.focus();
        }
        if (errors?.checkEmployeeEligibilityValue) {
            checkEmployeeEligibilityValueRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            checkEmployeeEligibilityValueRef.current?.focus();
        }
        if (errors?.hasAnyFixedHead) {
            hasAnyFixedHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            hasAnyFixedHeadRef.current?.focus();
        }
        // if (errors?.isEsicHead) {
        //     isEsicHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     isEsicHeadRef.current?.focus();
        // }
        // if (errors?.isEsicHead) {
        //     isEsicHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     isEsicHeadRef.current?.focus();
        // }
        if (errors?.isHeadForOtRate) {
            isHeadForOtRateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            isHeadForOtRateRef.current?.focus();
        }
        if (errors?.isHeadForOtRateValue) {
            isHeadForOtRateValueRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            isHeadForOtRateValueRef.current?.focus();
        }
        if (errors?.headTitle) {
            headTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            headTitleRef.current?.focus();
        }
        if (errors?.payrollHeadType) {
            payrollHeadTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            payrollHeadTypeRef.current?.focus();
        }
        if (errors?.visibleHeadInPayslip) {
            visibleHeadInPayslipRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            visibleHeadInPayslipRef.current?.focus();
        }
        if (errors?.headTitleForPayslip) {
            headTitleForPayslipRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            headTitleForPayslipRef.current?.focus();
        }
        if (errors?.headAgeCriteria) {
            headAgeCriteriaRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            headAgeCriteriaRef.current?.focus();
        }
        if (errors?.headAgeNumber) {
            headAgeNumberRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            headAgeNumberRef.current?.focus();
        }
        if (errors?.calculateHead) {
            calculateHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            calculateHeadRef.current?.focus();
        }
        if (errors?.payableOrLOPDays) {
            payableOrLOPDaysRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            payableOrLOPDaysRef.current?.focus();
        }
        if (errors?.payableOrLOPDaysHead) {
            payableOrLOPDaysHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            payableOrLOPDaysHeadRef.current?.focus();
        }
        if (errors?.calculateOnSlabValue) {
            calculateOnSlabValueRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            calculateOnSlabValueRef.current?.focus();
        }
        if (errors?.slabHeads) {
            slabHeadsRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            slabHeadsRef.current?.focus();
        }
        if (errors?.slabHeadSub) {
            slabHeadSubRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            slabHeadSubRef.current?.focus();
        }
        // if (errors?.payableDayHead) {
        //     payableDayHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     payableDayHeadRef.current?.focus();
        // }
        // if (errors?.presentDayHead) {
        //     presentDayHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     presentDayHeadRef.current?.focus();
        // }
        if (errors?.fixedRate) {
            fixedRateRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            fixedRateRef.current?.focus();
        }
        if (errors?.sumOfHead) {
            sumOfHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            sumOfHeadRef.current?.focus();
        }
        if (errors?.subOfHead) {
            subOfHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            subOfHeadRef.current?.focus();
        }
        // if (errors?.operator1) {
        //     operator1Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     operator1Ref.current?.focus();
        // }
        // if (errors?.inputValue1) {
        //     inputValue1Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     inputValue1Ref.current?.focus();
        // }
        // if (errors?.operator2) {
        //     operator2Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     operator2Ref.current?.focus();
        // }
        // if (errors?.inputValue2) {
        //     inputValue2Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     inputValue2Ref.current?.focus();
        // }
        // if (errors?.operator3) {
        //     operator3Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     operator3Ref.current?.focus();
        // }
        // if (errors?.inputValue3) {
        //     inputValue3Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     inputValue3Ref.current?.focus();
        // }
        // if (errors?.operator4) {
        //     operator4Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     operator4Ref.current?.focus();
        // }
        // if (errors?.inputValue4) {
        //     inputValue4Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     inputValue4Ref.current?.focus();
        // }
        // if (errors?.operator5) {
        //     operator5Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     operator5Ref.current?.focus();
        // }
        // if (errors?.inputValue5) {
        //     inputValue5Ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     inputValue5Ref.current?.focus();
        // }
        if (errors?.calculationFrequency) {
            calculationFrequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            calculationFrequencyRef.current?.focus();
        }
        if (errors?.monthlyFrequency) {
            monthlyFrequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyFrequencyRef.current?.focus();
        }
        if (errors?.yearlyFrequency) {
            yearlyFrequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            yearlyFrequencyRef.current?.focus();
        }
        if (errors?.halfYearlyFrequency) {
            halfYearlyFrequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            halfYearlyFrequencyRef.current?.focus();
        }
        if (errors?.quarterlyFrequency) {
            quarterlyFrequencyRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            quarterlyFrequencyRef.current?.focus();
        }
        if (errors?.onboardingCtc) {
            onboardingCtcRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            onboardingCtcRef.current?.focus();
        }
        if(errors?.otherEarnings){
            otherEarningsRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            otherEarningsRef.current?.focus();

        }
        // if(errors?.otherEarningsInAttendance){
        //     otherEarningsInAttendanceRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     otherEarningsInAttendanceRef.current?.focus();
        // }
        // if (errors?.onboardingCtcTypeRef) {
        //     onboardingCtcTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     onboardingCtcTypeRef.current?.focus();
        // }
        if (errors?.headValueToBe) {
            headValueToBeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            headValueToBeRef.current?.focus();
        }
        if (errors?.monthlyGross) {
            monthlyGrossRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyGrossRef.current?.focus();
        }
        if (errors?.monthlyGrossType) {
            monthlyGrossTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyGrossTypeRef.current?.focus();
        }
        if (errors?.eeStatutoryDeduction) {
            eeStatutoryDeductionRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            eeStatutoryDeductionRef.current?.focus();
        }
        if (errors?.eeStatutoryDeductionType) {
            eeStatutoryDeductionTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            eeStatutoryDeductionTypeRef.current?.focus();
        }
        if (errors?.erStatutoryContribution) {
            erStatutoryContributionRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            erStatutoryContributionRef.current?.focus();
        }
        if (errors?.erStatutoryContributionType) {
            erStatutoryContributionTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            erStatutoryContributionTypeRef.current?.focus();
        }
        if (errors?.monthlyOtherEarnings) {
            monthlyOtherEarningsRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyOtherEarningsRef.current?.focus();
        }
        if (errors?.monthlyOtherEarningsType) {
            monthlyOtherEarningsTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyOtherEarningsTypeRef.current?.focus();
        }
        // if (errors?.isPartOfMonthlyCtc) {
        //     isPartOfMonthlyCtcRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     isPartOfMonthlyCtcRef.current?.focus();
        // }
        // if (errors?.isPartOfMonthlyCtcType) {
        //     isPartOfMonthlyCtcTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     isPartOfMonthlyCtcTypeRef.current?.focus();
        // }
        if (errors?.monthlyDeduction) {
            monthlyDeductionRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyDeductionRef.current?.focus();
        }
        if (errors?.monthlyDeductionType) {
            monthlyDeductionTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlyDeductionTypeRef.current?.focus();
        }
        if (errors?.isStatutory) {
            isStatutoryRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isStatutoryRef.current?.focus();
        }
        if (errors?.isExGratia) {
            isExGratiaRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isExGratiaRef.current?.focus();
        }
        if (errors?.isStatutoryType) {
            isStatutoryTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isStatutoryTypeRef.current?.focus();
        }
        if (errors?.isGratuity) {
            isGratuityRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isGratuityRef.current?.focus();
        }
        // if (errors?.effectOnNetPay) {
        //     effectOnNetPayRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     effectOnNetPayRef.current?.focus();
        // }
        // if (errors?.effectOnNetPayType) {
        //     effectOnNetPayTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     effectOnNetPayTypeRef.current?.focus();
        // }
        if (errors?.componentLeaveEncashment) {
            componentLeaveEncashmentRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            componentLeaveEncashmentRef.current?.focus();
        }
        if (errors?.leavesToBeEncashed) {
            leavesToBeEncashedRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            leavesToBeEncashedRef.current?.focus();
        }
        if (errors?.isMinCapping) {
            isMinCappingRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMinCappingRef.current?.focus();
        }
        if (errors?.isMinCappingInput) {
            isMinCappingInputRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMinCappingInputRef.current?.focus();
        }
        if (errors?.isMaxCapping) {
            isMaxCappingRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMaxCappingRef.current?.focus();
        }
        if (errors?.isMaxCappingInput) {
            isMaxCappingInputRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMaxCappingInputRef.current?.focus();
        }
        if (errors?.isMaxCappingHeadSum) {
            isMaxCappingHeadSumRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMaxCappingHeadSumRef.current?.focus();
        }
        if (errors?.isMaxCappingHeadSub) {
            isMaxCappingHeadSubRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isMaxCappingHeadSubRef.current?.focus();
        }
        if (errors?.monthlySalaryRegister) {
            monthlySalaryRegisterRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlySalaryRegisterRef.current?.focus();
        }
        if (errors?.monthlySalaryRegisterType) {
            monthlySalaryRegisterTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            monthlySalaryRegisterTypeRef.current?.focus();
        }
        if (errors?.dependsOnIndividualEmployee) {
            dependsOnIndividualEmployeeRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            dependsOnIndividualEmployeeRef.current?.focus();
        }
        if (errors?.isCreateEarnedHead) {
            isCreateEarnedHeadRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
            isCreateEarnedHeadRef.current?.focus();
        }
        // if (errors?.componentStateWiseCriteria) {
        //     componentStateWiseCriteriaRef.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
        //     componentStateWiseCriteriaRef.current?.focus();
        // }

    }, [errors]);

    const getInfo = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryHeadInfo?company_salary_head_id=${company_salary_head_id}`, { headers }).then((response) => {
            const { success, salary_heads } = response.data;
            console.log("salary_heads", salary_heads);
            if (success === true) {
                setFormData({
                    headTitle: salary_heads[0]?.company_salary_head,
                    is_editable: salary_heads[0]?.is_editable,
                    payrollHeadType: salary_heads[0]?.salary_head_type,
                    visibleHeadInPayslip: salary_heads[0]?.show_in_payslip,
                    headTitleForPayslip: salary_heads[0]?.salary_head_name_for_payslip,
                    headAgeCriteria: salary_heads[0]?.age_criteria,
                    checkEmployeeEligibility: salary_heads[0]?.have_to_check_employee_eligibility,
                    checkEmployeeEligibilityValue: salary_heads[0]?.have_to_check_employee_eligibility_value,
                    hasAnyFixedHead: salary_heads[0]?.have_fixed_head,
                    hasAnyFixedHeadValue: salary_heads[0]?.have_fixed_head_value,
                    // isEsicHead: salary_heads[0]?.have_fixed_head_value,
                    isHeadForOtRate: salary_heads[0]?.have_OT_rate,
                    isHeadForOtRateValue: salary_heads[0]?.have_OT_rate_value,
                    headAgeNumber: salary_heads[0]?.age_criteria_value,
                    calculateHead: salary_heads[0]?.how_to_calculate_this_head,
                    payableOrLOPDays: salary_heads[0]?.calculate_on_attendance_value,
                    payableOrLOPDaysHead: salary_heads[0]?.calculate_on_attendance_head_value,
                    calculateOnSlabValue: salary_heads[0]?.calculate_on_slab_value,
                    slabHeads: salary_heads[0]?.depends_on_head,
                    slabHeadSub: salary_heads[0]?.depends_on_head_sub,
                    // payableDayHead: salary_heads[0]?.payable_days_head,
                    // presentDayHead: salary_heads[0]?.present_days_head,
                    fixedRate: salary_heads[0]?.calculate_on_fixed_rate_value,
                    sumOfHead: salary_heads[0]?.calculate_on_formula_componets_1,
                    subOfHead: salary_heads[0]?.calculate_on_formula_componets_2,
                    calculateOnFormulaComponentsValue1: salary_heads[0]?.calculate_on_formula_components_value1 || "2",
                    calculateOnFormulaComponentsValue2: salary_heads[0]?.calculate_on_formula_components_value2 || "2",
                    calculateOnFormulaComponentsValue3: salary_heads[0]?.calculate_on_formula_components_value3 || "2",
                    calculateOnFormulaComponentsValue4: salary_heads[0]?.calculate_on_formula_components_value4 || "2",
                    calculateOnFormulaComponentsValue5: salary_heads[0]?.calculate_on_formula_components_value5 || "2",
                    calculateOnFormulaComponentsValueHead1: salary_heads[0]?.calculate_on_formula_components_value_head1,
                    calculateOnFormulaComponentsValueHead2: salary_heads[0]?.calculate_on_formula_components_value_head2,
                    calculateOnFormulaComponentsValueHead3: salary_heads[0]?.calculate_on_formula_components_value_head3,
                    calculateOnFormulaComponentsValueHead4: salary_heads[0]?.calculate_on_formula_components_value_head4,
                    calculateOnFormulaComponentsValueHead5: salary_heads[0]?.calculate_on_formula_components_value_head5,
                    operator1: salary_heads[0]?.calculate_on_formula_operator1,
                    inputValue1: salary_heads[0]?.calculate_on_formula_value1,
                    operator2: salary_heads[0]?.calculate_on_formula_operator2,
                    inputValue2: salary_heads[0]?.calculate_on_formula_value2,
                    operator3: salary_heads[0]?.calculate_on_formula_operator3,
                    inputValue3: salary_heads[0]?.calculate_on_formula_value3,
                    operator4: salary_heads[0]?.calculate_on_formula_operator4,
                    inputValue4: salary_heads[0]?.calculate_on_formula_value4,
                    operator5: salary_heads[0]?.calculate_on_formula_operator5,
                    inputValue5: salary_heads[0]?.calculate_on_formula_value5,
                    calculationFrequency: salary_heads[0]?.calculation_frequency,
                    monthlyFrequency: salary_heads[0]?.calculation_frequency_monthly_value,
                    yearlyFrequency: salary_heads[0]?.calculation_frequency_yearly_value,
                    halfYearly1Frequency: salary_heads[0]?.calculation_frequency_half_yearly_value,
                    quarterlyFrequency: salary_heads[0]?.calculation_frequency_quarterly_value,
                    onboardingCtc: salary_heads[0]?.is_part_of_ctc,
                    otherEarnings:salary_heads[0]?.show_this_head_in_other_salary_import,
                    // otherEarningsInAttendance:salary_heads[0]?.is_part_of_attendence,
                    headValueToBe:salary_heads[0]?.head_round_off_type,
                    monthlyGross: salary_heads[0]?.is_part_of_gross,
                    monthlyGrossType: salary_heads[0]?.is_part_of_gross_type,
                    eeStatutoryDeduction: salary_heads[0]?.is_part_of_ee_statutory_deducation,
                    eeStatutoryDeductionType: salary_heads[0]?.is_part_of_ee_statutory_deducation_type,
                    erStatutoryContribution: salary_heads[0]?.is_part_of_er_statutory_contribution,
                    erStatutoryContributionType: salary_heads[0]?.is_part_of_er_statutory_contribution_type,
                    monthlyOtherEarnings: salary_heads[0]?.is_part_of_earning,
                    monthlyOtherEarningsType: salary_heads[0]?.is_part_of_earning_type,
                    // isPartOfMonthlyCtc: salary_heads[0]?.is_part_of_monthly_ctc,
                    // isPartOfMonthlyCtcType: salary_heads[0]?.is_part_of_monthly_ctc_type,
                    monthlyDeduction: salary_heads[0]?.is_part_of_deductions,
                    monthlyDeductionType: salary_heads[0]?.is_part_of_deductions_type,
                    isStatutory: salary_heads[0]?.used_to_calculate_statutory_bonus,
                    isStatutoryType: salary_heads[0]?.used_to_calculate_statutory_bonus_type,
                    isExGratia: salary_heads[0]?.used_to_calculate_ex_gratia,
                    isGratuity: salary_heads[0]?.used_to_calculate_gratuity,
                    // effectOnNetPay: salary_heads[0]?.does_effect_on_net_pay,
                    // effectOnNetPayType: salary_heads[0]?.does_effect_on_net_pay_type,
                    componentLeaveEncashment: salary_heads[0]?.used_to_calculate_leave_encashment,
                    leavesToBeEncashed: salary_heads[0]?.will_be_used_for_leave_encash_leave_types,
                    isMinCapping: salary_heads[0]?.have_min_cap_to_calculate_amount,
                    isMinCappingInput: salary_heads[0]?.have_min_cap_to_calculate_amount_value,
                    isMaxCapping: salary_heads[0]?.have_max_cap_to_calculate_amount,
                    isMaxCappingInput: salary_heads[0]?.have_max_cap_to_calculate_amount_value,
                    isMaxCappingHeadSum: salary_heads[0]?.check_max_cap_on_heads_sum,
                    isMaxCappingHeadSub: salary_heads[0]?.check_max_cap_on_heads_sub,
                    monthlySalaryRegister: salary_heads[0]?.is_part_of_monthly_salary_register,
                    monthlySalaryRegisterType: salary_heads[0]?.is_part_of_monthly_salary_register_type,
                    consideredArrearHead: salary_heads[0]?.is_arrear_head,
                    dependsOnIndividualEmployee: salary_heads[0]?.does_depend_on_individual_employee_selection,
                    isCreateEarnedHead: salary_heads[0]?.have_to_create_earned_component_for_this_fixed_head,
                    // componentStateWiseCriteria: salary_heads[0]?.have_state_wise_criteria,
                });
            } 
            else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            }
            setLoadingList(false);
        })
        .catch((error)=>{
            setLoadingList(false);
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong.",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            })
        });
    }
    const getLeaveTypeList = (typelist = 1) => {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Masters/GetLeaveTypeListSandbox`, {
                params: { typelist: typelist },
                headers,
            })
            .then((response) => {
                console.log("getLeaveTypeList=>>", response);
                var data = response.data;
                let temp=[];
                if (response.data.success === true) {
                    data?.data?.forEach((val) => {
                        if(val?.leave_hide==0){
                            temp.push({ value: val?.leave_type_id, label: val?.leave_type_name });
                        }
                        
                    });
                    console.log("temp",temp);
                    setLeaveOptions(temp);
                }
                console.log("temp", temp);
            });
    };
    useEffect(() => {
        getLeaveTypeList();
        if (company_salary_head_id) {
            setLoadingList(true);
            getInfo();
        }
        headTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        headTitleRef.current?.focus();
    }, []);

    const validateForm = () => {
        let errors = {}
        if (!formData?.headTitle) {
            errors.headTitle = "Head Title is required!"
            return errors
        }
        if (!formData?.payrollHeadType) {
            errors.payrollHeadType = "Payroll Head Type is required!"
            return errors
        }
        if (!formData?.visibleHeadInPayslip) {
            errors.visibleHeadInPayslip = "Visibility of head in payslip is required!"
            return errors
        }
        if (formData?.visibleHeadInPayslip === "1" && !formData?.headTitleForPayslip) {
            errors.headTitleForPayslip = "Head Title for payslip is required!"
            return errors
        }
        if (!formData?.headAgeCriteria) {
            errors.headAgeCriteria = "This is Required!"
            return errors
        }
        if (formData?.headAgeCriteria === "1" && !formData?.headAgeNumber) {
            errors.headAgeCriteria = "This is Required!"
            return errors
        }
        if (!formData?.checkEmployeeEligibility) {
            errors.checkEmployeeEligibility = "This is Required!"
            return errors
        }
        if (formData?.checkEmployeeEligibility == "1" && !formData?.checkEmployeeEligibilityValue) {
            errors.checkEmployeeEligibilityValue = "This is Required!"
            return errors
        }
        if (formData?.payrollHeadType !== "Fixed Component" && !formData?.hasAnyFixedHead) {
            errors.hasAnyFixedHead = "This is Required!"
            return errors
        }
        if (formData?.payrollHeadType !== "Fixed Component" && formData?.hasAnyFixedHead == "1" && !formData?.hasAnyFixedHeadValue) {
            errors.hasAnyFixedHeadValue = "This is Required!"
            return errors
        }
        if (formData?.payrollHeadType === "Other Earnings" && !formData?.isHeadForOtRate) {
            errors.isHeadForOtRate = "This is Required!"
            return errors
        }
        if (formData?.payrollHeadType === "Other Earnings" && formData?.isHeadForOtRate === "1" && !formData?.isHeadForOtRateValue) {
            errors.isHeadForOtRateValue = "This is Required!"
            return errors
        }
        if (!formData?.calculateHead) {
            errors.calculateHead = "This is Required!"
            return errors
        }
        if (formData?.calculateHead === "1" && !formData?.payableOrLOPDays) {
            errors.payableOrLOPDays = "This is Required!"
            return errors
        }
        if (formData?.calculateHead === "1" && formData?.payableOrLOPDays && !formData?.payableOrLOPDaysHead) {
            errors.payableDayHead = "This is Required!"
            return errors
        }
        // if (formData?.calculateHead === "1" && formData?.payableOrLOPDays === "1" && !formData?.payableDayHead) {
        //     errors.payableDayHead = "This is Required!"
        //     return errors
        // }
        // if (formData?.calculateHead === "1" && formData?.payableOrLOPDays === "2" && !formData?.presentDayHead) {
        //     errors.presentDayHead = "This is Required!"
        //     return errors
        // }
        if (formData?.calculateHead === "2" && !formData?.fixedRate) {
            errors.fixedRate = "This is Required!"
            return errors
        }
        if (formData?.calculateHead === "4" && !formData?.calculateOnSlabValue) {
            errors.calculateOnSlabValue = "This is Required!"
            return errors
        }
        if (formData?.calculateHead === "4" && formData?.calculateOnSlabValue && !formData?.slabHeads) {
            errors.slabHeads = "Slab Head is Required!"
            return errors
        }
        // if (formData?.calculateHead === "4" && formData?.calculateOnSlabValue && !formData?.slabHeadSub) {
        //     errors.slabHeadSub = "Slab Head is Required!"
        //     return errors
        // }
        if (formData?.calculateHead === "5" && !formData?.sumOfHead) {
            errors.sumOfHead = "This is Required!"
            return errors
        }
        // if (formData?.calculateHead === "5" && !formData?.subOfHead) {
        //     errors.subOfHead = "This is Required!"
        //     return errors
        // }
        if (!formData?.calculationFrequency) {
            errors.calculationFrequency = "This is Required!"
            return errors
        }
        if (formData?.calculationFrequency === "Monthly" && !formData?.monthlyFrequency) {
            errors.monthlyFrequency = "This is Required!"
            return errors
        }
        if (formData?.calculationFrequency === "Yearly" && !formData?.yearlyFrequency) {
            errors.yearlyFrequency = "This is Required!"
            return errors
        }
        if (formData?.calculationFrequency === "Half Yearly" && !formData?.halfYearlyFrequency) {
            errors.halfYearlyFrequency = "This is Required!"
            return errors
        }
        if (formData?.calculationFrequency === "Quarterly" && !formData?.quarterlyFrequency) {
            errors.quarterlyFrequency = "This is Required!"
            return errors
        }
        if(!formData?.onboardingCtc){
            errors.onboardingCtc = "This is Required!"
            return errors
        }
        if((formData?.payrollHeadType === "Other Earnings" || formData?.payrollHeadType === "Other Deductions") && !formData?.otherEarnings){
            errors.otherEarnings = "This is Required!"
            return errors
        }
        // if(!formData?.otherEarningsInAttendance){
        //     errors.otherEarningsInAttendance = "This is Required!"
        //     return errors
        // }
        if(!formData?.headValueToBe){
            errors.headValueToBe = "This is Required!"
            return errors
        }
        if (!formData?.monthlyGross) {
            errors.monthlyGross = "This is Required!"
            return errors
        }
        if (formData?.monthlyGross === "1" && !formData?.monthlyGrossType) {
            errors.monthlyGrossType = "This is Required!"
            return errors
        }
        if (!formData?.eeStatutoryDeduction) {
            errors.eeStatutoryDeduction = "This is Required!"
            return errors
        }
        if (formData?.eeStatutoryDeduction === "1" && !formData?.eeStatutoryDeductionType) {
            errors.eeStatutoryDeductionType = "This is Required!"
            return errors
        }
        if (!formData?.erStatutoryContribution) {
            errors.erStatutoryContribution = "This is Required!"
            return errors
        }
        if (formData?.erStatutoryContribution === "1" && !formData?.erStatutoryContributionType) {
            errors.erStatutoryContributionType = "This is Required!"
            return errors
        }
        if (!formData?.monthlyOtherEarnings) {
            errors.monthlyOtherEarnings = "This is Required!"
            return errors
        }
        if (formData?.monthlyOtherEarnings === "1" && !formData?.monthlyOtherEarningsType) {
            errors.monthlyOtherEarningsType = "This is Required!"
            return errors
        }
        if (!formData?.consideredArrearHead) {
            errors.consideredArrearHead = "This is Required!"
            return errors
        }
        // if (!formData?.operator1) {
        //     errors.operator1 = "This is Required!"
        // }
        // if (formData?.operator1 && (!formData?.calculateOnFormulaComponentsValue1 || !formData?.inputValue1)) {
        //     if(!formData?.calculateOnFormulaComponentsValue1){
        //         errors.calculateOnFormulaComponentsValue1 = "This is Required!"
        //     }
        //     if(!formData?.inputValue1){
        //         errors.inputValue1 = "This is Required!"
        //     }

        //     return errors
        // }
        // if (!formData?.isPartOfMonthlyCtc) {
        //     errors.isPartOfMonthlyCtc = "This is Required!"
        //     return errors
        // }
        // if (formData?.isPartOfMonthlyCtc === "1" && !formData?.isPartOfMonthlyCtcType) {
        //     errors.isPartOfMonthlyCtcType = "This is Required!"
        //     return errors
        // }
        if (!formData?.monthlyDeduction) {
            errors.monthlyDeduction = "This is Required!"
            return errors
        }
        if (formData?.monthlyDeduction === "1" && !formData?.monthlyDeductionType) {
            errors.monthlyDeductionType = "This is Required!"
            return errors
        }
        // if (!formData?.isStatutory) {
        //     errors.isStatutory = "This is Required!"
        //     return errors
        // }
        // if (formData?.isStatutory === "1" && !formData?.isStatutoryType) {
        //     errors.isStatutory = "This is Required!"
        //     return errors
        // }
        // if (!formData?.isExGratia) {
        //     errors.isExGratia = "This is Required!"
        //     return errors
        // }
        // if (!formData?.isGratuity) {
        //     errors.isGratuity = "This is Required!"
        //     return errors
        // }
        // if (!formData?.effectOnNetPay) {
        //     errors.effectOnNetPay = "This is Required!"
        //     return errors
        // }
        // if (formData?.effectOnNetPay === "1" && !formData?.effectOnNetPayType) {
        //     errors.effectOnNetPayType = "This is Required!"
        //     return errors
        // }
        if (!formData?.componentLeaveEncashment) {
            errors.componentLeaveEncashment = "This is Required!"
            return errors
        }
        if (formData?.componentLeaveEncashment==="1" && !formData?.leavesToBeEncashed) {
            errors.leavesToBeEncashed = "This is Required!"
            return errors
        }
        if (!formData?.isMinCapping) {
            errors.isMinCapping = "This is Required!"
            return errors
        }
        if (formData?.isMinCapping === "1" && !formData?.isMinCappingInput) {
            errors.isMinCappingInput = "This is Required!"
            return errors
        }
        if (!formData?.isMaxCapping) {
            errors.isMaxCapping = "This is Required!"
            return errors
        }
        if (formData?.isMaxCapping === "1" && !formData?.isMaxCappingInput) {
            errors.isMaxCappingInput = "This is Required!"
            return errors
        }
        // if (formData?.isMaxCapping === "1" && !formData?.isMaxCappingHeadSum) {
        //     errors.isMaxCappingHeadSum = "This is Required!"
        //     return errors
        // }
        // if (formData?.isMaxCapping === "1" && !formData?.isMaxCappingHeadSub) {
        //     errors.isMaxCappingHeadSub = "This is Required!"
        //     return errors
        // }
        if (!formData?.monthlySalaryRegister) {
            errors.monthlySalaryRegister = "This is Required!"
            return errors
        }
        if (formData?.monthlySalaryRegister === "1" && !formData?.monthlySalaryRegisterType) {
            errors.monthlySalaryRegisterType = "This is Required!"
            return errors
        }
        // if (!formData?.dependsOnIndividualEmployee) {
        //     errors.dependsOnIndividualEmployee = "This is Required!"
        //     return errors
        // }
        if (formData?.payrollHeadType === "Fixed Component" && !formData?.isCreateEarnedHead) {
            errors.isCreateEarnedHead = "This is Required!"
            return errors
        }
        // if (!formData?.componentStateWiseCriteria) {
        //     errors.componentStateWiseCriteria = "This is Required!"
        //     return errors
        // }


        return errors;

    }

    const getList = async () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryHeadList`, { params: { limit: 1000, page: pagination?.page, date: currentDateAndTime() , }, headers }).then((response) => {

            let data = response.data;
            console.log(response?.data);
            if (response.data.success === true) {
                let headRows = data?.result?.data.map((val) => {
                    return { value: val?.company_salary_head_id, label: val?.company_salary_head }
                });
                let headRows2 = data?.result?.data.filter((val) => {
                    if (val?.salary_head_type === "Fixed Component") {
                        return { value: val?.company_salary_head_id, label: val?.company_salary_head }
                    }
                });
                headRows2 = headRows2?.map((val) => {
                    return { value: val?.company_salary_head_id, label: val?.company_salary_head }
                });
                console.log("headRows2", headRows2);
                setRows(headRows);
                setFixedHeadRows(headRows2);
                setPagination({
                    next: data?.result?.next,
                    prev: data?.result?.prev,
                    page: data?.result?.page,
                    total_records: data?.result?.total_records,
                    total_pages: data?.result?.total_pages,
                });
                setLoadingList(false);
            } else {
                setLoadingList(false);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    const getSlabList = async () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/StatutorySlabsList`, {
            params: {
                limit: 999,
                page: pagination?.page,
            }, headers
        }).then((response) => {

            let data = response.data;
            console.log(response?.data);
            if (response.data.success === true) {
                let temp = data?.result?.data?.map((val) => {
                    return { value: val?.statutory_slab_id, label: val?.statutory_type }
                });
                console.log("temp", temp);
                setSlabOptions(temp);
            } else {

            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getList();
        getSlabList();
    }, []);



    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = validateForm();
        console.log("errors 1", errors);
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }
        setLoading(true);
        let data = {
            company_salary_head_id: company_salary_head_id || null,
            headTitle: formData?.headTitle,
            payrollHeadType: formData?.payrollHeadType,
            visibleHeadInPayslip: formData?.visibleHeadInPayslip,
            headTitleForPayslip: formData?.headTitleForPayslip,
            headAgeCriteria: formData?.headAgeCriteria,
            checkEmployeeEligibility: formData?.checkEmployeeEligibility,
            checkEmployeeEligibilityValue: formData?.checkEmployeeEligibilityValue,
            hasAnyFixedHead: formData?.hasAnyFixedHead,
            hasAnyFixedHeadValue: formData?.hasAnyFixedHeadValue,
            isHeadForOtRate: formData?.isHeadForOtRate,
            isHeadForOtRateValue: formData?.isHeadForOtRateValue,
            headAgeNumber: formData?.headAgeNumber,
            calculateHead: formData?.calculateHead,
            payableOrLOPDays: formData?.payableOrLOPDays,
            payableOrLOPDaysHead: formData?.payableOrLOPDaysHead,
            calculateOnSlabValue: formData?.calculateOnSlabValue,
            slabHeads: formData?.slabHeads,
            slabHeadSub: formData?.slabHeadSub,
            // payableDayHead: formData?.payableDayHead,
            // presentDayHead: formData?.presentDayHead,
            fixedRate: formData?.fixedRate,
            sumOfHead: formData?.sumOfHead,
            subOfHead: formData?.subOfHead,
            calculateOnFormulaComponentsValue1: formData?.calculateOnFormulaComponentsValue1,
            calculateOnFormulaComponentsValue2: formData?.calculateOnFormulaComponentsValue2,
            calculateOnFormulaComponentsValue3: formData?.calculateOnFormulaComponentsValue3,
            calculateOnFormulaComponentsValue4: formData?.calculateOnFormulaComponentsValue4,
            calculateOnFormulaComponentsValue5: formData?.calculateOnFormulaComponentsValue5,
            calculateOnFormulaComponentsValueHead1: formData?.calculateOnFormulaComponentsValueHead1,
            calculateOnFormulaComponentsValueHead2: formData?.calculateOnFormulaComponentsValueHead2,
            calculateOnFormulaComponentsValueHead3: formData?.calculateOnFormulaComponentsValueHead3,
            calculateOnFormulaComponentsValueHead4: formData?.calculateOnFormulaComponentsValueHead4,
            calculateOnFormulaComponentsValueHead5: formData?.calculateOnFormulaComponentsValueHead5,
            operator1: formData?.operator1,
            inputValue1: formData?.inputValue1,
            operator2: formData?.operator2,
            inputValue2: formData?.inputValue2,
            operator3: formData?.operator3,
            inputValue3: formData?.inputValue3,
            operator4: formData?.operator4,
            inputValue4: formData?.inputValue4,
            operator5: formData?.operator5,
            inputValue5: formData?.inputValue5,
            calculationFrequency: formData?.calculationFrequency,
            monthlyFrequency: formData?.monthlyFrequency,
            yearlyFrequency: formData?.yearlyFrequency,
            halfYearlyFrequency: formData?.halfYearlyFrequency,
            quarterlyFrequency: formData?.quarterlyFrequency,
            onboardingCtc:formData?.onboardingCtc,
            otherEarnings:formData?.otherEarnings,
            // otherEarningsInAttendance:formData?.otherEarningsInAttendance, 
            headValueToBe:formData?.headValueToBe,
            monthlyGross: formData?.monthlyGross,
            monthlyGrossType: formData?.monthlyGrossType,
            eeStatutoryDeduction: formData?.eeStatutoryDeduction,
            eeStatutoryDeductionType: formData?.eeStatutoryDeductionType,
            erStatutoryContribution: formData?.erStatutoryContribution,
            erStatutoryContributionType: formData?.erStatutoryContributionType,
            monthlyOtherEarnings: formData?.monthlyOtherEarnings,
            monthlyOtherEarningsType: formData?.monthlyOtherEarningsType,
            // isPartOfMonthlyCtc: formData?.isPartOfMonthlyCtc,
            // isPartOfMonthlyCtcType: formData?.isPartOfMonthlyCtcType,
            monthlyDeduction: formData?.monthlyDeduction,
            monthlyDeductionType: formData?.monthlyDeductionType,
            isStatutory: formData?.isStatutory,
            isStatutoryType: formData?.isStatutoryType,
            isExGratia: formData?.isExGratia,
            isGratuity: formData?.isGratuity,
            // effectOnNetPay: formData?.effectOnNetPay,
            // effectOnNetPayType: formData?.effectOnNetPayType,
            componentLeaveEncashment: formData?.componentLeaveEncashment,
            leavesToBeEncashed: formData?.leavesToBeEncashed,
            isMinCapping: formData?.isMinCapping,
            isMinCappingInput: formData?.isMinCappingInput,
            isMaxCapping: formData?.isMaxCapping,
            isMaxCappingInput: formData?.isMaxCappingInput,
            isMaxCappingHeadSum: formData?.isMaxCappingHeadSum,
            isMaxCappingHeadSub: formData?.isMaxCappingHeadSub,
            monthlySalaryRegister: formData?.monthlySalaryRegister,
            monthlySalaryRegisterType: formData?.monthlySalaryRegisterType,
            consideredArrearHead: formData?.consideredArrearHead,
            dependsOnIndividualEmployee: formData?.dependsOnIndividualEmployee,
            isCreateEarnedHead: formData?.isCreateEarnedHead,
            // componentStateWiseCriteria: formData?.componentStateWiseCriteria,
            date: currentDateAndTime(),
        }

        const headers = apiHeaderJSON;
        // setLoading(true);
        axios
            .post(`${apiURL}Payrolls/CreateSalaryHead`, data, {
                headers,
            })
            .then((response) => {
                const { success, have_to_create_earned } = response.data;
                if (success === true) {
                    setSuccessMsg(response.data.message);
                    setErrorMsg(false);
                    setFormData({
                        headTitle: have_to_create_earned || "",
                        // is_editable: have_to_create_earned || "",
                        payrollHeadType: have_to_create_earned ? "Earning" : null,
                        visibleHeadInPayslip: null,
                        headTitleForPayslip: "",
                        headAgeCriteria: null,
                        checkEmployeeEligibility: null,
                        checkEmployeeEligibilityValue: null,
                        hasAnyFixedHead: null,
                        hasAnyFixedHeadValue: null,
                        isHeadForOtRate: null,
                        isHeadForOtRateValue: "0",
                        headAgeNumber: null,
                        calculateHead: null,
                        payableOrLOPDays: null,
                        payableOrLOPDaysHead: null,
                        calculateOnSlabValue: null,
                        slabHeads: null,
                        // payableDayHead: null,
                        // presentDayHead: null,
                        fixedRate: null,
                        sumOfHead: null,
                        subOfHead: null,
                        calculateOnFormulaComponentsValue1: "2",
                        calculateOnFormulaComponentsValue2: "2",
                        calculateOnFormulaComponentsValue3: "2",
                        calculateOnFormulaComponentsValue4: "2",
                        calculateOnFormulaComponentsValue5: "2",
                        calculateOnFormulaComponentsValueHead1: null,
                        calculateOnFormulaComponentsValueHead2: null,
                        calculateOnFormulaComponentsValueHead3: null,
                        calculateOnFormulaComponentsValueHead4: null,
                        calculateOnFormulaComponentsValueHead5: null,
                        operator1: null,
                        inputValue1: null,
                        operator2: null,
                        inputValue2: null,
                        operator3: null,
                        inputValue3: null,
                        operator4: null,
                        inputValue4: null,
                        operator5: null,
                        inputValue5: null,
                        calculationFrequency: null,
                        monthlyFrequency: null,
                        yearlyFrequency: null,
                        halfYearlyFrequency: null,
                        quarterlyFrequency: null,
                        onboardingCtc:null,
                        otherEarnings:null,
                        // otherEarningsInAttendance:null,
                        headValueToBe:null,
                        monthlyGross: null,
                        monthlyGrossType: null,
                        eeStatutoryDeduction: null,
                        eeStatutoryDeductionType: null,
                        erStatutoryContribution: null,
                        erStatutoryContributionType: null,
                        monthlyOtherEarnings: null,
                        monthlyOtherEarningsType: null,
                        isPartOfMonthlyCtc: null,
                        isPartOfMonthlyCtcType: null,
                        monthlyDeduction: null,
                        monthlyDeductionType: null,
                        isStatutory: null,
                        isStatutoryType: null,
                        isExGratia: null,
                        isGratuity: null,
                        effectOnNetPay: null,
                        effectOnNetPayType: null,
                        componentLeaveEncashment: null,
                        leavesToBeEncashed: null,
                        isMinCapping: null,
                        isMinCappingInput: null,
                        isMaxCapping: null,
                        isMaxCappingInput: null,
                        monthlySalaryRegister: null,
                        monthlySalaryRegisterType: null,
                        dependsOnIndividualEmployee: null,
                        isCreateEarnedHead: null,
                        // componentStateWiseCriteria: null,
                    });
                    getList();
                    if (have_to_create_earned) {
                        headTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        headTitleRef.current?.focus();
                    }
                    if (company_salary_head_id) {
                        getInfo();
                    }
                } else {
                    setSuccessMsg(false);
                    setErrorMsg(response.data.message);
                }
            });
        setLoading(false);

    }

    return (
        <div>
            {!loadingList ? (
                <div class="main-content">
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={company_salary_head_id ? "Update Payroll Head" : `Create Payroll Head`} primary={`Home`} />
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">
                                        {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"}
                                    </h4>
                                    <NavLink className="btn btn-success btn-sm" 
                                    to={`/PayrollHeadMaster?abs=${encodeData(decodedDataId)}${title && headType ? `&title=${title}&type=${headType}` : title ? `&title=${title}` : headType ? `&type=${headType}` : ""}${(title || headType) && (page || limit )? `&page=${page}&limit=${limit}`: (page || limit )? `&page=${page}&limit=${limit}` : ""}`} accordion
                                    // onClick={()=>{ navigate(-1) }}
                                    >
                                        <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                                    </NavLink>
                                </div>

                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form
                                                id='payrollHeadCreation'
                                                onSubmit={(e) => handleSubmit(e)}
                                                className="row settings-form"
                                            >
                                                {/* head title */}
                                                <div className="col-md-6 mt-3">
                                                    <div>
                                                        <label>
                                                            Head title
                                                        </label>
                                                    </div>
                                                    <div className="w-100">
                                                        <input
                                                            type="text"
                                                            id="head_title"
                                                            name="head_title"
                                                            placeholder="Enter Title"
                                                            ref={headTitleRef}
                                                            value={formData?.headTitle}
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    "headTitle",
                                                                    e.target.value
                                                                )
                                                            }
                                                            disabled={formData?.is_editable ==="0"}
                                                            className={`form-control w-100 ${errors?.headTitle ? "is-invalid" : ""}`}
                                                        />
                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                    </div>
                                                    <div className=" text-danger">{errors?.headTitle ? errors?.headTitle : null}</div>
                                                </div>
                                                {/* payroll head type */}
                                                <div ref={payrollHeadTypeRef} className="col-md-6 mt-3">
                                                    <label htmlFor="leave_gender" className="form-label">
                                                        Type Of Head
                                                    </label>
                                                    <Select
                                                        id="payroll_head_type"
                                                        name="payroll_head_type"
                                                        value={headOptions?.find(
                                                            (val) => val?.value === formData?.payrollHeadType
                                                        )}
                                                        onChange={(selectedOption) => {
                                                            handleChange("payrollHeadType", selectedOption?.value,)
                                                        }}
                                                        options={headOptions}
                                                        placeholder="Select Head Type"
                                                        className={`w-100 ${errors?.payrollHeadType ? "is-invalid" : " "}`}
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                borderColor: errors?.payrollHeadType ? "red" : base.borderColor,
                                                                boxShadow: errors?.payrollHeadType ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                "&:hover": {
                                                                    borderColor: errors?.payrollHeadType ? "red" : base.borderColor,
                                                                },
                                                            }),
                                                        }}

                                                    // isDisabled={!formData?.headTitle}
                                                    />
                                                    <div className=' text-danger'>{errors?.payrollHeadType ? errors?.payrollHeadType : null}</div>
                                                </div>
                                                {/* Show This Head In Payslip */}
                                                <div ref={visibleHeadInPayslipRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Show This Head In Payslip</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="visible_head_in_payslip_yes"
                                                            name="visible_head_in_payslip"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="1"
                                                            checked={formData?.visibleHeadInPayslip === "1"}
                                                            onChange={() =>
                                                                handleChange("visibleHeadInPayslip", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="visible_head_in_payslip_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="visible_head_in_payslip_no"
                                                            name="visible_head_in_payslip"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="0"
                                                            checked={formData?.visibleHeadInPayslip === "0"}
                                                            onChange={() =>
                                                                handleChange("visibleHeadInPayslip", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="visible_head_in_payslip_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.visibleHeadInPayslip ? errors?.visibleHeadInPayslip : null}</div>
                                                    {formData?.visibleHeadInPayslip === "1" && (
                                                        <div ref={headTitleForPayslipRef} className="mx-4">
                                                            <div>
                                                                <label>
                                                                    Head title for payslip
                                                                </label>
                                                            </div>
                                                            <div className="w-100">
                                                                <input
                                                                    type="text"
                                                                    id="head_title"
                                                                    name="head_title"
                                                                    placeholder="Enter Title"
                                                                    value={formData?.headTitleForPayslip}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            "headTitleForPayslip",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.headTitleForPayslip ? "is-invalid" : ""}`}
                                                                />
                                                                {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                            </div>
                                                            <div className=" text-danger">{errors?.headTitleForPayslip ? errors?.headTitleForPayslip : null}</div>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Where this component will effect */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Where this component will effect?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="checkbox"
                                                            id="component_will_effect"
                                                            name="component_will_effect"
                                                            value="1"
                                                            checked={formData?.componentWillEffect === "1"}
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    "componentWillEffect",
                                                                    e.target.checked ? "1" : "0"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="component_will_effect"
                                                            className="form-check-label"
                                                        >
                                                            Applicable on Location and Department
                                                        </label>
                                                    </div> <br />
                                                    {formData?.componentWillEffect === "1" && (
                                                        <>

                                                            <div className="col-md-6 mt-3 settings-section">
                                                                <label>Location</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("componentLocation", selectedOptions)}
                                                                    placeholder="Select location"
                                                                    isMulti
                                                                    className={`${errors.componentLocation ? "is-invalid" : ""}`}
                                                                    options={headOptions}
                                                                    value={formData.componentLocation ? formData.componentLocation.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                />
                                                                {errors.componentLocation && <div className="text-danger">{errors.componentLocation}</div>}
                                                            </div>
                                                            <div className="col-md-6 settings-section">
                                                                <label>Department</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("componentDepartment", selectedOptions)}
                                                                    placeholder="Select department"
                                                                    isMulti
                                                                    className={`${errors.componentDepartment ? "is-invalid" : ""}`}
                                                                    options={headOptions}
                                                                    value={formData.componentDepartment ? formData.componentDepartment.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                />
                                                                {errors.componentDepartment && <div className="text-danger">{errors.componentDepartment}</div>}
                                                            </div>
                                                            <div className="col-md-6  settings-section">
                                                                <label>Grades</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("componentGrades", selectedOptions)}
                                                                    placeholder="Select grades"
                                                                    isMulti
                                                                    className={`${errors.componentGrades ? "is-invalid" : ""}`}
                                                                    options={headOptions}
                                                                    value={formData.componentGrades ? formData.componentGrades.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                />
                                                                {errors.componentGrades && <div className="text-danger">{errors.componentGrades}</div>}
                                                            </div>
                                                        </>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("componentWillEffect", "2")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_part_of_monthly_ctc_no"
                                                            name="is_part_of_monthly_ctc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="2"
                                                            checked={formData?.componentWillEffect === "2"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_part_of_monthly_ctc_no"
                                                            className="form-check-label"
                                                        >
                                                            Applicable on grade
                                                        </label>
                                                    </div> <br />
                                                    {formData?.componentWillEffect === "2" && (
                                                        <div className="col-md-6  settings-section">
                                                            <label>Grades</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("componentGrades", selectedOptions)}
                                                                placeholder="Select grades"
                                                                isMulti
                                                                className={`${errors.componentGrades ? "is-invalid" : ""}`}
                                                                options={headOptions}
                                                                value={formData.componentGrades ? formData.componentGrades.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                            />
                                                            {errors.componentGrades && <div className="text-danger">{errors.componentGrades}</div>}
                                                        </div>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("componentWillEffect", "3")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_part_of_monthly_ctc_yes"
                                                            name="is_part_of_monthly_ctc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="3"
                                                            checked={formData?.componentWillEffect === "3"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_part_of_monthly_ctc_yes"
                                                            className="form-check-label"
                                                        >
                                                            Applicable on Employee
                                                        </label>
                                                    </div> 
                                                    <div className=" text-danger">{errors?.componentWillEffect ? errors?.componentWillEffect : null}</div>
                                                </div> */}

                                                {/* Does this head have age criteria */}
                                                <div ref={headAgeCriteriaRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this head have age criteria</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_age_criteria_yes"
                                                            name="head_age_criteria"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="1"
                                                            checked={formData?.headAgeCriteria === "1"}
                                                            onChange={() =>
                                                                handleChange("headAgeCriteria", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_age_criteria_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_age_criteria_no"
                                                            name="head_age_criteria"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="0"
                                                            checked={formData?.headAgeCriteria === "0"}
                                                            onChange={() =>
                                                                handleChange("headAgeCriteria", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_age_criteria_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.headAgeCriteria ? errors?.headAgeCriteria : null}</div>
                                                    {formData?.headAgeCriteria === "1" && (
                                                        <div ref={headAgeNumberRef} className="mx-4 ">
                                                            <div>
                                                                <label>
                                                                    Max age
                                                                </label>
                                                            </div>
                                                            <div className="w-100 ">
                                                                <input
                                                                    type="number"
                                                                    id="head_title"
                                                                    name="head_title"
                                                                    placeholder="Enter Age"

                                                                    value={formData?.headAgeNumber}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            "headAgeNumber",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.headAgeNumber ? "is-invalid" : ""}`}
                                                                />
                                                                {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                            </div>
                                                            <div className=" text-danger">{errors?.headAgeNumber ? errors?.headAgeNumber : null}</div>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Have to check employee eligibility for this head */}
                                                <div ref={checkEmployeeEligibilityRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Have to check employee eligibility for this head</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="check_employee_eligibility_yes"
                                                            name="employee_eligibility"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="1"
                                                            checked={formData?.checkEmployeeEligibility === "1"}
                                                            onChange={() =>
                                                                handleChange("checkEmployeeEligibility", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="check_employee_eligibility_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="check_employee_eligibility_no"
                                                            name="employee_eligibility"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="0"
                                                            checked={formData?.checkEmployeeEligibility === "0"}
                                                            onChange={() =>
                                                                handleChange("checkEmployeeEligibility", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="check_employee_eligibility_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.checkEmployeeEligibility ? errors?.checkEmployeeEligibility : null}</div>
                                                    {formData?.checkEmployeeEligibility === "1" && (
                                                        <div ref={checkEmployeeEligibilityValueRef} className="mt-1 mx-4 ">
                                                            <Select
                                                                id="check_employee_eligibility_value"
                                                                name="check_employee_eligibility_value"
                                                                value={eligibilityValue?.find(
                                                                    (val) => val?.value === formData?.checkEmployeeEligibilityValue
                                                                )}
                                                                onChange={(selectedOption) => {
                                                                    handleChange("checkEmployeeEligibilityValue", selectedOption?.value,)
                                                                }}
                                                                options={eligibilityValue}
                                                                placeholder="Select Head Type"
                                                                className={`w-100 ${errors?.checkEmployeeEligibilityValue ? "is-invalid" : " "}`}
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        borderColor: errors?.checkEmployeeEligibilityValue ? "red" : base.borderColor,
                                                                        boxShadow: errors?.checkEmployeeEligibilityValue ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                        "&:hover": {
                                                                            borderColor: errors?.checkEmployeeEligibilityValue ? "red" : base.borderColor,
                                                                        },
                                                                    }),
                                                                }}


                                                            />
                                                            <div className=' text-danger'>{errors?.checkEmployeeEligibilityValue ? errors?.checkEmployeeEligibilityValue : null}</div>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Does this head have any fixed head? */}
                                                {(formData?.payrollHeadType !== "Fixed Component" && formData?.payrollHeadType) && (
                                                    <div ref={hasAnyFixedHeadRef} className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label>Does this head have any fixed head?</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="hasAnyFixedHead_yes"
                                                                name="hasAnyFixedHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="1"
                                                                checked={formData?.hasAnyFixedHead === "1"}
                                                                onChange={() =>
                                                                    handleChange("hasAnyFixedHead", "1")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="hasAnyFixedHead_yes"
                                                                className="form-check-label"
                                                            >
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="hasAnyFixedHead_no"
                                                                name="hasAnyFixedHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="0"
                                                                checked={formData?.hasAnyFixedHead === "0"}
                                                                onChange={() =>
                                                                    handleChange("hasAnyFixedHead", "0")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="hasAnyFixedHead_no"
                                                                className="form-check-label"
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                        <div className=" text-danger">{errors?.hasAnyFixedHead ? errors?.hasAnyFixedHead : null}</div>
                                                        {formData?.hasAnyFixedHead === "1" && (
                                                            <div ref={hasAnyFixedHeadValueRef} className="col-md-6 mx-4">
                                                                <label htmlFor="leave_gender" className="form-label">
                                                                    Select Fixed Head
                                                                </label>
                                                                <Select
                                                                    id="payroll_head_type"
                                                                    name="payroll_head_type"
                                                                    value={fixedHeadRows?.find(
                                                                        (val) => val?.value == formData?.hasAnyFixedHeadValue
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("hasAnyFixedHeadValue", selectedOption?.value,)
                                                                    }}
                                                                    options={fixedHeadRows}
                                                                    placeholder="Select Fixed Head"
                                                                    className={`w-100 ${errors?.hasAnyFixedHeadValue ? "is-invalid" : " "}`}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.hasAnyFixedHeadValue ? "red" : base.borderColor,
                                                                            boxShadow: errors?.hasAnyFixedHeadValue ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.hasAnyFixedHeadValue ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}

                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.hasAnyFixedHeadValue ? errors?.hasAnyFixedHeadValue : null}</div>
                                                            </div>
                                                        )}
                                                    </div>

                                                )}
                                                {/* does this head has OT rate? */}
                                                {formData?.payrollHeadType === "Other Earnings" && (
                                                    <div ref={isHeadForOtRateRef} className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label>does this head has OT rate?</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isHeadForOtRate_yes"
                                                                name="isHeadForOtRate"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="1"
                                                                checked={formData?.isHeadForOtRate === "1"}
                                                                onChange={() =>
                                                                    handleChange("isHeadForOtRate", "1")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isHeadForOtRate_yes"
                                                                className="form-check-label"
                                                            >
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isHeadForOtRate_no"
                                                                name="isHeadForOtRate"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="0"
                                                                checked={formData?.isHeadForOtRate === "0"}
                                                                onChange={() =>
                                                                    handleChange("isHeadForOtRate", "0")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isHeadForOtRate_no"
                                                                className="form-check-label"
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                        <div className=" text-danger">{errors?.isHeadForOtRate ? errors?.isHeadForOtRate : null}</div>
                                                        {formData?.isHeadForOtRate === "1" && (
                                                            <div ref={isHeadForOtRateValueRef} className="col-md-6 mt-3">
                                                                <label htmlFor="leave_gender" className="form-label">
                                                                    Select OT Rate
                                                                </label>
                                                                <Select
                                                                    id="payroll_head_type"
                                                                    name="payroll_head_type"
                                                                    value={otOptions?.find(
                                                                        (val) => val?.value === formData?.isHeadForOtRateValue
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("isHeadForOtRateValue", selectedOption?.value,)
                                                                    }}
                                                                    options={otOptions}
                                                                    placeholder="Select Rate"
                                                                    className={`w-100 ${errors?.isHeadForOtRateValue ? "is-invalid" : " "}`}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.isHeadForOtRateValue ? "red" : base.borderColor,
                                                                            boxShadow: errors?.isHeadForOtRateValue ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.isHeadForOtRateValue ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}

                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <small className=' text-muted text-danger'>(This rate will calculate {formData?.isHeadForOtRateValue === "0" ? "Earn OT on fixed rate" :
                                                                    formData?.isHeadForOtRateValue === "1" ? "Earned OT ( @ 1 Rate)" :
                                                                        formData?.isHeadForOtRateValue === "1.5" ? "Earned OT ( @ 1.5 Rate)" :
                                                                            formData?.isHeadForOtRateValue === "2" ? "Earned OT ( @ 2 Rate)" :
                                                                                null})</small>
                                                                <div className=' text-danger'>{errors?.isHeadForOtRateValue ? errors?.isHeadForOtRateValue : null}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* {(formData?.payrollHeadType === "EE Statutory Deduction" || formData?.payrollHeadType === "ER Statutory Contribution")  && (
                                                    <div ref={isEsicHeadRef} className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label>Is this ESIC Head?</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isEsicHead_yes"
                                                                name="isEsicHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="1"
                                                                checked={formData?.isEsicHead === "1"}
                                                                onChange={() =>
                                                                    handleChange("isEsicHead", "1")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isEsicHead_yes"
                                                                className="form-check-label"
                                                            >
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isEsicHead_no"
                                                                name="isEsicHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="0"
                                                                checked={formData?.isEsicHead === "0"}
                                                                onChange={() =>
                                                                    handleChange("isEsicHead", "0")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isEsicHead_no"
                                                                className="form-check-label"
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                        <div className=" text-danger">{errors?.isEsicHead ? errors?.isEsicHead : null}</div>
                                                        {formData?.isEsicHead === "1" && (
                                                            <div ref={isHeadForOtRateValueRef} className="col-md-6 mt-3">
                                                                <label htmlFor="leave_gender" className="form-label">
                                                                    Select Months
                                                                </label>
                                                                <Select
                                                                    id="payroll_head_type"
                                                                    name="payroll_head_type"
                                                                    value={otOptions?.find(
                                                                        (val) => val?.value === formData?.isHeadForOtRateValue
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("isHeadForOtRateValue", selectedOption?.value,)
                                                                    }}
                                                                    options={otOptions}
                                                                    placeholder="Select Rate"
                                                                    className={`w-100 ${errors?.isHeadForOtRateValue ? "is-invalid" : " "}`}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.isHeadForOtRateValue ? "red" : base.borderColor,
                                                                            boxShadow: errors?.isHeadForOtRateValue ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.isHeadForOtRateValue ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}

                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <small className=' text-muted text-danger'>(This rate will calculate {formData?.isHeadForOtRateValue === "0" ? "Earn OT on fixed rate" :
                                                                    formData?.isHeadForOtRateValue === "1" ? "Earned OT ( @ 1 Rate)" :
                                                                        formData?.isHeadForOtRateValue === "1.5" ? "Earned OT ( @ 1.5 Rate)" :
                                                                            formData?.isHeadForOtRateValue === "2" ? "Earned OT ( @ 2 Rate)" :
                                                                                null})</small>
                                                                <div className=' text-danger'>{errors?.isHeadForOtRateValue ? errors?.isHeadForOtRateValue : null}</div>
                                                            </div>
                                                        )}
                                                    </div>

                                                )} */}
                                                {/* How to calculate this head */}
                                                <div ref={calculateHeadRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>How to calculate this head?</label>
                                                    </div>
                                                    <div onClick={() =>
                                                        handleChange("calculateHead", "1")}
                                                        className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="on_attendance_1"
                                                            name="on_attendance"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.calculateHead === "1"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="on_attendance_1"
                                                            className="form-check-label"
                                                        >
                                                            On Attendance
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculateHead === "1" && (
                                                        <>
                                                            <div ref={payableOrLOPDaysRef} className="mx-4 ">
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="payable_days"
                                                                        name="payable_days"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.payableOrLOPDays === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "payableOrLOPDays",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="payable_days"
                                                                        className="form-check-label"
                                                                    >
                                                                        On Payable Days
                                                                    </label>
                                                                </div>
                                                                {/* {formData?.payableOrLOPDays === "1" && (
                                                                    <>
                                                                        <div ref={payableDayHeadRef} >
                                                                            <label>Head</label>
                                                                            <Select
                                                                                onChange={(selectedOptions) => handleMultiSelect("payableDayHead", selectedOptions)}
                                                                                placeholder="Select Head"
                                                                                isMulti
                                                                                className={`${errors.payableDayHead ? "is-invalid" : ""}`}
                                                                                options={rows}
                                                                                value={formData.payableDayHead ? formData.payableDayHead.split(',').map(id => rows.find(option => option.value === id)) : null}
                                                                            />
                                                                            {errors.payableDayHead && <div className="text-danger">{errors.payableDayHead}</div>}
                                                                        </div>
                                                                    </>
                                                                )} */}
                                                            </div>
                                                            <div className="mx-4">
                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="lop_days"
                                                                        name="lop_days"


                                                                        value={"2"}
                                                                        checked={formData?.payableOrLOPDays === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "payableOrLOPDays",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="lop_days"
                                                                        className="form-check-label"
                                                                    >
                                                                        On Present Days
                                                                    </label>
                                                                </div>
                                                                {/* {formData?.payableOrLOPDays === "2" && (
                                                                    <>
                                                                        <div ref={presentDayHeadRef} >
                                                                            <label>Head</label>
                                                                            <Select
                                                                                onChange={(selectedOptions) => handleMultiSelect("presentDayHead", selectedOptions)}
                                                                                placeholder="Select Head"
                                                                                isMulti
                                                                                className={`${errors.presentDayHead ? "is-invalid" : ""}`}
                                                                                options={rows}
                                                                                value={formData.presentDayHead ? formData.presentDayHead.split(',').map(id => rows.find(option => option.value === id)) : null}
                                                                            />
                                                                            {errors.presentDayHead && <div className="text-danger">{errors.presentDayHead}</div>}
                                                                        </div>
                                                                    </>
                                                                )} */}
                                                                <div className=" text-danger">{errors?.payableOrLOPDays ? errors?.payableOrLOPDays : null}</div>
                                                            </div>
                                                            <div className="mx-4">
                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="arrear_days"
                                                                        name="arrear_days"
                                                                        value={"3"}
                                                                        checked={formData?.payableOrLOPDays === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "payableOrLOPDays",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="arrear_days"
                                                                        className="form-check-label"
                                                                    >
                                                                        On Arrear Days
                                                                    </label>
                                                                </div>
                                                                {/* {formData?.payableOrLOPDays === "3" && (
                                                                    <>
                                                                        <div ref={presentDayHeadRef} >
                                                                            <label>Head</label>
                                                                            <Select
                                                                                onChange={(selectedOptions) => handleMultiSelect("presentDayHead", selectedOptions)}
                                                                                placeholder="Select Head"
                                                                                isMulti
                                                                                className={`${errors.presentDayHead ? "is-invalid" : ""}`}
                                                                                options={rows}
                                                                                value={formData.presentDayHead ? formData.presentDayHead.split(',').map(id => rows.find(option => option.value === id)) : null}
                                                                            />
                                                                            {errors.presentDayHead && <div className="text-danger">{errors.presentDayHead}</div>}
                                                                        </div>
                                                                    </>
                                                                )} */}
                                                                <div className=" text-danger">{errors?.payableOrLOPDays ? errors?.payableOrLOPDays : null}</div>
                                                            </div>
                                                            {formData?.payableOrLOPDays && (
                                                                <>
                                                                    <div ref={payableOrLOPDaysHeadRef} >
                                                                        <label>Payroll Heads</label>
                                                                        <Select
                                                                            onChange={(selectedOptions) => handleMultiSelect("payableOrLOPDaysHead", selectedOptions)}
                                                                            placeholder="Select Head"
                                                                            isMulti
                                                                            className={`${errors.payableOrLOPDaysHead ? "is-invalid" : ""}`}
                                                                            options={rows}
                                                                            value={formData.payableOrLOPDaysHead ? formData.payableOrLOPDaysHead.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                        />
                                                                        {errors.payableOrLOPDaysHead && <div className="text-danger">{errors.payableOrLOPDaysHead}</div>}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("calculateHead", "2")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="on_fixed_rate_2"
                                                            name="on_fixed_rate"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="2"
                                                            checked={formData?.calculateHead === "2"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="on_fixed_rate_2"
                                                            className="form-check-label"
                                                        >
                                                            On Fixed Rate
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculateHead === "2" && (
                                                        <div ref={fixedRateRef} className="mx-4 ">
                                                            <div>
                                                                <label>
                                                                    Fixed rate
                                                                </label>
                                                            </div>
                                                            <div className="w-100 ">
                                                                <input
                                                                    type="number"
                                                                    id="fixed_rate"
                                                                    name="fixed_rate"
                                                                    placeholder="Enter Fixed rate"

                                                                    value={formData?.fixedRate}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            "fixedRate",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.fixedRate ? "is-invalid" : ""}`}
                                                                />
                                                                {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                            </div>
                                                            <div className=" text-danger">{errors?.fixedRate ? errors?.fixedRate : null}</div>
                                                        </div>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("calculateHead", "3")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="on_input_value_3"
                                                            name="on_input_value"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="3"
                                                            checked={formData?.calculateHead === "3"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="on_input_value_3"
                                                            className="form-check-label"
                                                        >
                                                            On Input Value
                                                        </label>
                                                    </div> <br />
                                                    <div onClick={() =>
                                                        handleChange("calculateHead", "4")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="on_input_value_4"
                                                            name="on_input_value"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="4"
                                                            checked={formData?.calculateHead === "4"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="on_input_value_4"
                                                            className="form-check-label"
                                                        >
                                                            On Slab
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculateHead === "4" && (
                                                        <>
                                                            <div>
                                                                <div ref={calculateOnSlabValueRef} className=' w-100 form-check form-check-inline mt-1'>
                                                                    <Select
                                                                        options={statutorySlabOptions}
                                                                        value={formData?.calculateOnSlabValue ? statutorySlabOptions.find(option => option.value == formData?.calculateOnSlabValue) : null}
                                                                        onChange={(selectedOption) => handleChange("calculateOnSlabValue", selectedOption?.value)}
                                                                        placeholder={`Select Slab`}
                                                                    />
                                                                </div>

                                                                <div className=" text-danger col-md-5 mx-4">{errors?.calculateOnSlabValue ? errors?.calculateOnSlabValue : null}</div>
                                                            </div>
                                                            <div style={{ gridTemplateColumns: "1fr 1fr" }} className=' d-grid'>
                                                                <div ref={slabHeadsRef} className=' form-check form-check-inline' >
                                                                    <label>Sum(+)</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("slabHeads", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.slabHeads ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.slabHeads ? formData.slabHeads.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    <div className=" text-danger ">{errors?.slabHeads ? errors?.slabHeads : null}</div>
                                                                </div>
                                                                <div ref={slabHeadSubRef} className=' form-check form-check-inline' >
                                                                    <label>Sum(-)</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("slabHeadSub", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.slabHeadSub ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.slabHeadSub ? formData.slabHeadSub.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {/* <div className=" text-danger ">{errors?.slabHeadSub ? errors?.slabHeadSub : null}</div> */}
                                                                </div>
                                                            </div>

                                                        </>
                                                    )
                                                    }
                                                    <div onClick={() =>
                                                        handleChange("calculateHead", "5")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="on_input_value_5"
                                                            name="on_input_value"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="5"
                                                            checked={formData?.calculateHead === "5"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="on_input_value_5"
                                                            className="form-check-label"
                                                        >
                                                            On Formula
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.calculateHead ? errors?.calculateHead : null}</div>
                                                </div>
                                                {formData?.calculateHead === "5" && (
                                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                        <div ref={sumOfHeadRef} >
                                                            <label>Sum(+)</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("sumOfHead", selectedOptions)}
                                                                placeholder="Select Head"
                                                                isMulti
                                                                className={`${errors.sumOfHead ? "is-invalid" : ""}`}
                                                                options={rows}
                                                                value={formData.sumOfHead ? formData.sumOfHead.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                            />
                                                            {errors.sumOfHead && <div className="text-danger">{errors.sumOfHead}</div>}
                                                        </div>
                                                        <div
                                                            // ref={subOfHeadRef}
                                                            className="">
                                                            <label>Sub(-)</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("subOfHead", selectedOptions)}
                                                                placeholder="Select Head"
                                                                isMulti
                                                                // className={`${errors.subOfHead ? "is-invalid" : ""}`}
                                                                options={rows}
                                                                value={formData.subOfHead ? formData.subOfHead.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                            />
                                                            {/* {errors.subOfHead && <div className="text-danger">{errors.subOfHead}</div>} */}
                                                        </div>
                                                        {/* operator 1 */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                            <div className="">
                                                                <label htmlFor="operator1" className="form-label">
                                                                    Operator
                                                                </label>
                                                                <Select
                                                                    id="operator1"
                                                                    name="operator1"
                                                                    value={operatorOptions?.find(
                                                                        (val) => val?.value === formData?.operator1
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("operator1", selectedOption?.value,)
                                                                    }}
                                                                    options={operatorOptions}
                                                                    placeholder="Select Operator"
                                                                // ref={operator1Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.operator1 ? errors?.operator1 : null}</div>
                                                            </div>
                                                            <div className="">
                                                                <label htmlFor="calculateOnFormulaComponentsValue1" className="form-label">
                                                                    Value Type
                                                                </label>
                                                                <Select
                                                                    id="calculateOnFormulaComponentsValue1"
                                                                    name="calculateOnFormulaComponentsValue1"
                                                                    value={headOrValueOptions?.find(
                                                                        (val) => val?.value === formData?.calculateOnFormulaComponentsValue1
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("calculateOnFormulaComponentsValue1", selectedOption?.value,)
                                                                    }}
                                                                    options={headOrValueOptions}
                                                                    placeholder="Select Value Type"
                                                                // ref={calculateOnFormulaComponentsValue1Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.calculateOnFormulaComponentsValue1 ? errors?.calculateOnFormulaComponentsValue1 : null}</div>
                                                            </div>
                                                        </div>
                                                        {formData?.calculateOnFormulaComponentsValue1 === "1" && (
                                                            <>
                                                                <div >
                                                                    <label>Head</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("calculateOnFormulaComponentsValueHead1", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.calculateOnFormulaComponentsValueHead1 ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.calculateOnFormulaComponentsValueHead1 ? formData.calculateOnFormulaComponentsValueHead1.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {errors.calculateOnFormulaComponentsValueHead1 && <div className="text-danger">{errors.calculateOnFormulaComponentsValueHead1}</div>}
                                                                </div>
                                                            </>
                                                        )}
                                                        {formData?.calculateOnFormulaComponentsValue1 === "2" && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue1"
                                                                            name="inputValue1"
                                                                            placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue1}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue1",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            className={`form-control ${errors?.inputValue1 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue1 ? errors?.inputValue1 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {(formData?.calculateOnFormulaComponentsValue1 === "3" || formData?.calculateOnFormulaComponentsValue1 === "4") && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            // id="inputValue1"
                                                                            // name="inputValue1"

                                                                            // ref={headAgeNumberRef}
                                                                            value={""}
                                                                            // onChange={(e) =>
                                                                            //     handleChange(
                                                                            //         "inputValue1",
                                                                            //         e.target.value
                                                                            //     )
                                                                            // }
                                                                            disabled
                                                                            className={`form-control ${errors?.inputValue1 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue1 ? errors?.inputValue1 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* operator 2 */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                            <div className="">
                                                                <label htmlFor="operator2" className="form-label">
                                                                    Operator
                                                                </label>
                                                                <Select
                                                                    id="operator2"
                                                                    name="operator2"
                                                                    value={operatorOptions?.find(
                                                                        (val) => val?.value === formData?.operator2
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("operator2", selectedOption?.value,)
                                                                    }}
                                                                    options={operatorOptions}
                                                                    placeholder="Select Operator"
                                                                // ref={operator2Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.operator2 ? errors?.operator2 : null}</div>
                                                            </div>
                                                            <div className="">
                                                                <label htmlFor="calculateOnFormulaComponentsValue2" className="form-label">
                                                                    Value Type
                                                                </label>
                                                                <Select
                                                                    id="calculateOnFormulaComponentsValue2"
                                                                    name="calculateOnFormulaComponentsValue2"
                                                                    value={headOrValueOptions?.find(
                                                                        (val) => val?.value === formData?.calculateOnFormulaComponentsValue2
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("calculateOnFormulaComponentsValue2", selectedOption?.value,)
                                                                    }}
                                                                    options={headOrValueOptions}
                                                                    placeholder="Select Value Type"
                                                                // ref={calculateOnFormulaComponentsValue2Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.calculateOnFormulaComponentsValue2 ? errors?.calculateOnFormulaComponentsValue2 : null}</div>
                                                            </div>
                                                        </div>
                                                        {formData?.calculateOnFormulaComponentsValue2 === "1" && (
                                                            <>
                                                                <div >
                                                                    <label>Head</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("calculateOnFormulaComponentsValueHead2", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.calculateOnFormulaComponentsValueHead2 ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.calculateOnFormulaComponentsValueHead2 ? formData.calculateOnFormulaComponentsValueHead2.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {errors.calculateOnFormulaComponentsValueHead2 && <div className="text-danger">{errors.calculateOnFormulaComponentsValueHead2}</div>}
                                                                </div>
                                                            </>
                                                        )}
                                                        {formData?.calculateOnFormulaComponentsValue2 === "2" && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue2"
                                                                            name="inputValue2"
                                                                            placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue2}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue2",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            className={`form-control ${errors?.inputValue2 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue2 ? errors?.inputValue2 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {(formData?.calculateOnFormulaComponentsValue2 === "3" || formData?.calculateOnFormulaComponentsValue2 === "4") && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue2"
                                                                            name="inputValue2"

                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue2}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue2",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            disabled
                                                                            className={`form-control ${errors?.inputValue2 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue2 ? errors?.inputValue2 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* operator 3 */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                            <div className="">
                                                                <label htmlFor="operator3" className="form-label">
                                                                    Operator
                                                                </label>
                                                                <Select
                                                                    id="operator3"
                                                                    name="operator3"
                                                                    value={operatorOptions?.find(
                                                                        (val) => val?.value === formData?.operator3
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("operator3", selectedOption?.value,)
                                                                    }}
                                                                    options={operatorOptions}
                                                                    placeholder="Select Operator"
                                                                // ref={operator3Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.operator3 ? errors?.operator3 : null}</div>
                                                            </div>
                                                            <div className="">
                                                                <label htmlFor="calculateOnFormulaComponentsValue3" className="form-label">
                                                                    Value Type
                                                                </label>
                                                                <Select
                                                                    id="calculateOnFormulaComponentsValue3"
                                                                    name="calculateOnFormulaComponentsValue3"
                                                                    value={headOrValueOptions?.find(
                                                                        (val) => val?.value === formData?.calculateOnFormulaComponentsValue3
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("calculateOnFormulaComponentsValue3", selectedOption?.value,)
                                                                    }}
                                                                    options={headOrValueOptions}
                                                                    placeholder="Select Value Type"
                                                                // ref={calculateOnFormulaComponentsValue3Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.calculateOnFormulaComponentsValue3 ? errors?.calculateOnFormulaComponentsValue3 : null}</div>
                                                            </div>
                                                        </div>
                                                        {formData?.calculateOnFormulaComponentsValue3 === "1" && (
                                                            <>
                                                                <div >
                                                                    <label>Head</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("calculateOnFormulaComponentsValueHead3", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.calculateOnFormulaComponentsValueHead3 ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.calculateOnFormulaComponentsValueHead3 ? formData.calculateOnFormulaComponentsValueHead3.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {errors.calculateOnFormulaComponentsValueHead3 && <div className="text-danger">{errors.calculateOnFormulaComponentsValueHead3}</div>}
                                                                </div>
                                                            </>
                                                        )}
                                                        {formData?.calculateOnFormulaComponentsValue3 === "2" && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue3"
                                                                            name="inputValue3"
                                                                            placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue3}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue3",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            className={`form-control ${errors?.inputValue3 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue3 ? errors?.inputValue3 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {(formData?.calculateOnFormulaComponentsValue3 === "3" || formData?.calculateOnFormulaComponentsValue3 === "4") && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue3"
                                                                            name="inputValue3"
                                                                            // placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue3}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue3",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            disabled
                                                                            className={`form-control ${errors?.inputValue3 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue3 ? errors?.inputValue3 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* operator 4 */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                            <div className="">
                                                                <label htmlFor="operator4" className="form-label">
                                                                    Operator
                                                                </label>
                                                                <Select
                                                                    id="operator4"
                                                                    name="operator4"
                                                                    value={operatorOptions?.find(
                                                                        (val) => val?.value === formData?.operator4
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("operator4", selectedOption?.value,)
                                                                    }}
                                                                    options={operatorOptions}
                                                                    placeholder="Select Operator"
                                                                // ref={operator4Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.operator4 ? errors?.operator4 : null}</div>
                                                            </div>
                                                            <div className="">
                                                                <label htmlFor="calculateOnFormulaComponentsValue4" className="form-label">
                                                                    Value Type
                                                                </label>
                                                                <Select
                                                                    id="calculateOnFormulaComponentsValue4"
                                                                    name="calculateOnFormulaComponentsValue4"
                                                                    value={headOrValueOptions?.find(
                                                                        (val) => val?.value === formData?.calculateOnFormulaComponentsValue4
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("calculateOnFormulaComponentsValue4", selectedOption?.value,)
                                                                    }}
                                                                    options={headOrValueOptions}
                                                                    placeholder="Select Value Type"
                                                                // ref={calculateOnFormulaComponentsValue4Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.calculateOnFormulaComponentsValue4 ? errors?.calculateOnFormulaComponentsValue4 : null}</div>
                                                            </div>
                                                        </div>
                                                        {formData?.calculateOnFormulaComponentsValue4 === "1" && (
                                                            <>
                                                                <div >
                                                                    <label>Head</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("calculateOnFormulaComponentsValueHead4", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.calculateOnFormulaComponentsValueHead4 ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.calculateOnFormulaComponentsValueHead4 ? formData.calculateOnFormulaComponentsValueHead4.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {errors.calculateOnFormulaComponentsValueHead4 && <div className="text-danger">{errors.calculateOnFormulaComponentsValueHead4}</div>}
                                                                </div>
                                                            </>
                                                        )}
                                                        {formData?.calculateOnFormulaComponentsValue4 === "2" && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue4"
                                                                            name="inputValue4"
                                                                            placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue4}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue4",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            className={`form-control ${errors?.inputValue4 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue4 ? errors?.inputValue4 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {(formData?.calculateOnFormulaComponentsValue4 === "3" || formData?.calculateOnFormulaComponentsValue4 === "4") && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            // placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={""}
                                                                            // onChange={(e) =>
                                                                            //     handleChange(
                                                                            //         "inputValue4",
                                                                            //         e.target.value
                                                                            //     )
                                                                            // }
                                                                            disabled={formData?.calculateOnFormulaComponentsValue4 === "3"}
                                                                            className={`form-control`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    {/* <div className=" text-danger">{errors?.inputValue4 ? errors?.inputValue4 : null}</div> */}
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* operator 5 */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                            <div className="">
                                                                <label htmlFor="operator5" className="form-label">
                                                                    Operator
                                                                </label>
                                                                <Select
                                                                    id="operator5"
                                                                    name="operator5"
                                                                    value={operatorOptions?.find(
                                                                        (val) => val?.value === formData?.operator5
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("operator5", selectedOption?.value,)
                                                                    }}
                                                                    options={operatorOptions}
                                                                    placeholder="Select Operator"
                                                                // ref={operator5Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.operator5 ? errors?.operator5 : null}</div>
                                                            </div>
                                                            <div className="">
                                                                <label htmlFor="calculateOnFormulaComponentsValue5" className="form-label">
                                                                    Value Type
                                                                </label>
                                                                <Select
                                                                    id="calculateOnFormulaComponentsValue5"
                                                                    name="calculateOnFormulaComponentsValue5"
                                                                    value={headOrValueOptions?.find(
                                                                        (val) => val?.value === formData?.calculateOnFormulaComponentsValue5
                                                                    )}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("calculateOnFormulaComponentsValue5", selectedOption?.value,)
                                                                    }}
                                                                    options={headOrValueOptions}
                                                                    placeholder="Select Value Type"
                                                                // ref={calculateOnFormulaComponentsValue5Ref}
                                                                // isDisabled={!formData?.headTitle}
                                                                />
                                                                <div className=' text-danger'>{errors?.calculateOnFormulaComponentsValue5 ? errors?.calculateOnFormulaComponentsValue5 : null}</div>
                                                            </div>
                                                        </div>
                                                        {formData?.calculateOnFormulaComponentsValue5 === "1" && (
                                                            <>
                                                                <div >
                                                                    <label>Head</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("calculateOnFormulaComponentsValueHead5", selectedOptions)}
                                                                        placeholder="Select Head"
                                                                        isMulti
                                                                        className={`${errors.calculateOnFormulaComponentsValueHead5 ? "is-invalid" : ""}`}
                                                                        options={rows}
                                                                        value={formData.calculateOnFormulaComponentsValueHead5 ? formData.calculateOnFormulaComponentsValueHead5.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                    />
                                                                    {errors.calculateOnFormulaComponentsValueHead5 && <div className="text-danger">{errors.calculateOnFormulaComponentsValueHead5}</div>}
                                                                </div>
                                                            </>
                                                        )}
                                                        {formData?.calculateOnFormulaComponentsValue5 === "2" && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue5"
                                                                            name="inputValue5"
                                                                            placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue5}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue5",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            className={`form-control ${errors?.inputValue5 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue5 ? errors?.inputValue5 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {(formData?.calculateOnFormulaComponentsValue5 === "3" || formData?.calculateOnFormulaComponentsValue5 === "4") && (
                                                            <>
                                                                <div className="">
                                                                    <div>
                                                                        <label>
                                                                            Input Value
                                                                        </label>
                                                                    </div>
                                                                    <div className=" ">
                                                                        <input
                                                                            type="number"
                                                                            id="inputValue5"
                                                                            name="inputValue5"
                                                                            // placeholder="Enter Value"
                                                                            // ref={headAgeNumberRef}
                                                                            value={formData?.inputValue5}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    "inputValue5",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            disabled={formData?.calculateOnFormulaComponentsValue5 === "3"}
                                                                            className={`form-control ${errors?.inputValue5 ? "is-invalid" : ""}`}
                                                                        />
                                                                        {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                    </div>
                                                                    <div className=" text-danger">{errors?.inputValue5 ? errors?.inputValue5 : null}</div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                                {/* What is head calculation frequency */}
                                                <div ref={calculationFrequencyRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>What is head calculation frequency?</label>
                                                    </div>
                                                    <div onClick={() =>
                                                        handleChange("calculationFrequency", "Monthly")}
                                                        className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="calculation_frequency_Monthly"
                                                            name="calculation_frequency"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="Monthly"
                                                            checked={formData?.calculationFrequency === "Monthly"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="calculation_frequency_Monthly"
                                                            className="form-check-label"
                                                        >
                                                            Monthly
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculationFrequency === "Monthly" && (
                                                        <>

                                                            <div className="col-md-6 mt-3 settings-section">
                                                                <label>Months</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("monthlyFrequency", selectedOptions)}
                                                                    placeholder="Select months"
                                                                    isMulti
                                                                    className={`${errors.monthlyFrequency ? "is-invalid" : ""}`}
                                                                    options={monthDataOptions}
                                                                    value={formData.monthlyFrequency ? formData.monthlyFrequency.split(',').map(id => monthDataOptions.find(option => option.value == id)) : null}
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: errors?.monthlyFrequency ? "red" : base.borderColor,
                                                                            boxShadow: errors?.monthlyFrequency ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                            "&:hover": {
                                                                                borderColor: errors?.monthlyFrequency ? "red" : base.borderColor,
                                                                            },
                                                                        }),
                                                                    }}
                                                                />
                                                                {errors.monthlyFrequency && <div className="text-danger">{errors.monthlyFrequency}</div>}
                                                            </div>
                                                        </>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("calculationFrequency", "Yearly")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="calculation_frequency_Yearly"
                                                            name="calculation_frequency"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="Yearly"
                                                            checked={formData?.calculationFrequency === "Yearly"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="calculation_frequency_Yearly"
                                                            className="form-check-label"
                                                        >
                                                            Yearly
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculationFrequency === "Yearly" && (
                                                        <div className="col-md-6  settings-section">
                                                            <label>month</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("yearlyFrequency", selectedOptions)}
                                                                placeholder="Select month"
                                                                isMulti
                                                                className={`${errors.yearlyFrequency ? "is-invalid" : ""}`}
                                                                options={monthDataOptions2}
                                                                value={formData.yearlyFrequency ? formData.yearlyFrequency.split(',').map(id => monthDataOptions2.find(option => option.value == id)) : null}
                                                            />
                                                            {errors.yearlyFrequency && <div className="text-danger">{errors.yearlyFrequency}</div>}
                                                        </div>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("calculationFrequency", "Half Yearly")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="calculation_frequency_Half Yearly"
                                                            name="calculation_frequency"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="Half Yearly"
                                                            checked={formData?.calculationFrequency === "Half Yearly"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="calculation_frequency_Half Yearly"
                                                            className="form-check-label"
                                                        >
                                                            Half Yearly
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculationFrequency === "Half Yearly" && (
                                                        <div className="col-md-6  settings-section">
                                                            <label>months</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("halfYearlyFrequency", selectedOptions)}
                                                                placeholder="Select months"
                                                                isMulti
                                                                className={`${errors.halfYearlyFrequency ? "is-invalid" : ""}`}
                                                                options={monthDataOptions2}
                                                                value={formData.halfYearlyFrequency ? formData.halfYearlyFrequency.split(',').map(id => monthDataOptions2.find(option => option.value == id)) : null}
                                                            />
                                                            {errors.halfYearlyFrequency && <div className="text-danger">{errors.halfYearlyFrequency}</div>}
                                                        </div>
                                                    )}
                                                    <div onClick={() =>
                                                        handleChange("calculationFrequency", "Quarterly")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="calculation_frequency_Quarterly"
                                                            name="calculation_frequency"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="Quarterly"
                                                            checked={formData?.calculationFrequency === "Quarterly"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="calculation_frequency_Quarterly"
                                                            className="form-check-label"
                                                        >
                                                            Quarterly
                                                        </label>
                                                    </div> <br />
                                                    {formData?.calculationFrequency === "Quarterly" && (
                                                        <div className="col-md-6  settings-section">
                                                            <label>months</label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("quarterlyFrequency", selectedOptions)}
                                                                placeholder="Select months"
                                                                isMulti
                                                                className={`${errors.quarterlyFrequency ? "is-invalid" : ""}`}
                                                                options={monthDataOptions2}
                                                                value={formData.quarterlyFrequency ? formData.quarterlyFrequency.split(',').map(id => monthDataOptions2.find(option => option.value == id)) : null}
                                                            />
                                                            {errors.quarterlyFrequency && <div className="text-danger">{errors.quarterlyFrequency}</div>}
                                                        </div>
                                                    )}
                                                    {/* <div onClick={() =>
                                                        handleChange("calculationFrequency", "User Defined")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="calculation_frequency_User Defined"
                                                            name="calculation_frequency"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="User Defined"
                                                            checked={formData?.calculationFrequency === "User Defined"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="calculation_frequency_User Defined"
                                                            className="form-check-label"
                                                        >
                                                            User Defined
                                                        </label>
                                                    </div> */}
                                                    <div className=" text-danger">{errors?.calculationFrequency ? errors?.calculationFrequency : null}</div>
                                                </div>
                                                {/* Does this head have statutory slab */}
                                                {/* <div className="col-md-12 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this head have statutory slab?</label>
                                                    </div>
                                                    <div onClick={() =>
                                                        handleChange("statutorySlab", "1")
                                                    } className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="statutory_lab_yes"
                                                            name="statutory_lab"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="1"
                                                            checked={formData?.statutorySlab === "1"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="statutory_lab_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="statutory_lab_no"
                                                            name="statutory_lab"
                                                            // disabled={!formData?.payrollHeadType}
                                                            value="0"
                                                            checked={formData?.statutorySlab === "0"}
                                                            onChange={() =>
                                                                handleChange("statutorySlab", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="statutory_lab_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.statutorySlab ? errors?.statutorySlab : null}</div>
                                                    {formData?.statutorySlab === "1" && (
                                                        <>
                                                            <div className=' d-flex align-content-center gap-3'>
                                                                <div className="">
                                                                    <label>State</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("slabState", selectedOptions)}
                                                                        placeholder="Select State"
                                                                        isMulti
                                                                        className={`${errors.slabState ? "is-invalid" : ""}`}
                                                                        options={headOptions}
                                                                        value={formData.slabState ? formData.slabState.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                    />
                                                                    {errors.slabState && <div className="text-danger">{errors.slabState}</div>}
                                                                </div>
                                                                <div className="">
                                                                    <label>Designation</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("slabDesignation", selectedOptions)}
                                                                        placeholder="Select designation"
                                                                        isMulti
                                                                        className={`${errors.slabDesignation ? "is-invalid" : ""}`}
                                                                        options={headOptions}
                                                                        value={formData.slabDesignation ? formData.slabDesignation.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                    />
                                                                    {errors.slabDesignation && <div className="text-danger">{errors.slabDesignation}</div>}
                                                                </div>
                                                                <div className="">
                                                                    <label>Grades</label>
                                                                    <Select
                                                                        onChange={(selectedOptions) => handleMultiSelect("slabGrade", selectedOptions)}
                                                                        placeholder="Select Grade"
                                                                        isMulti
                                                                        className={`${errors.slabGrade ? "is-invalid" : ""}`}
                                                                        options={headOptions}
                                                                        value={formData.slabGrade ? formData.slabGrade.split(',').map(id => headOptions.find(option => option.value === id)) : null}
                                                                    />
                                                                    {errors.slabGrade && <div className="text-danger">{errors.slabGrade}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 mt-4">
                                                                <div className='card '>
                                                                    <div style={{ "overflowY": "auto", "overflowX": "auto" }}>
                                                                        <table style={{ width: '140Input Value', }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                           
                                                                            <tbody>
                                                                                {
                                                                                    slabRows.map((row, idx) => {
                                                                                        return <tr >
                                                                                            <td >
                                                                                                <div style={{ "width": "8rem" }} className="form-check  form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="earned_slab_min"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Min Slab
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="earned_slab_min"
                                                                                                        name="earned_slab_min"
                                                                                                        placeholder="Enter min slab"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.earnedSlabMin}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "earnedSlabMin",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        className={`form-control w-100 ${errors?.earnedSlabMin ? "is-invalid" : ""}`}
                                                                                                    />

                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="earned_slab_max"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Max Slab
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="earned_slab_max"
                                                                                                        name="earned_slab_max"
                                                                                                        placeholder="Enter max slab"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.earnedSlabMax}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "earnedSlabMax",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.earnedSlabMin}
                                                                                                        className={`form-control w-100 ${errors?.earnedSlabMax ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div className="form-check w-100 form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="gender"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Gender
                                                                                                    </label>
                                                                                                    <Select
                                                                                                        id="gender"
                                                                                                        name="gender"
                                                                                                        value={genderOptions?.find(
                                                                                                            (val) => val?.value === row?.gender
                                                                                                        )}
                                                                                                        onChange={(selectedOption) => {
                                                                                                            handleSlabChange(idx, "gender", selectedOption?.value,)
                                                                                                        }}
                                                                                                        options={genderOptions}
                                                                                                        placeholder="Select"
                                                                                                        // ref={payrollHeadTypeRef}
                                                                                                        isDisabled={!row?.earnedSlabMax}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "10rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="employee_contribution"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Employee Contribution
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="employee_contribution"
                                                                                                        name="employee_contribution"
                                                                                                        placeholder="Enter contribution"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.employeeContribution}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "employeeContribution",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.gender}
                                                                                                        className={`form-control w-100 ${errors?.employeeContribution ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "10rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="employer_contribution"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Employer Contribution
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="employer_contribution"
                                                                                                        name="employer_contribution"
                                                                                                        placeholder="Enter contribution"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.employerContribution}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "employerContribution",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.employeeContribution}
                                                                                                        className={`form-control w-100 ${errors?.employerContribution ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "7rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="frequency"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Frequency
                                                                                                    </label>
                                                                                                    <Select
                                                                                                        id="frequency"
                                                                                                        name="frequency"
                                                                                                        value={frequencyOptions?.find(
                                                                                                            (val) => val?.value === row?.frequency
                                                                                                        )}
                                                                                                        onChange={(selectedOption) => {
                                                                                                            handleSlabChange(idx, "frequency", selectedOption?.value,)
                                                                                                        }}
                                                                                                        options={frequencyOptions}
                                                                                                        placeholder="Select"
                                                                                                        // ref={payrollHeadTypeRef}
                                                                                                        isDisabled={!row?.employerContribution}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "maxWidth": "15rem" }} className="form-check w-100 form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="months"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Months
                                                                                                    </label>
                                                                                                    <Select
                                                                                                        onChange={(selectedOptions) => handleSlabMultiSelect(idx, "months", selectedOptions)}
                                                                                                        placeholder="Select months"
                                                                                                        isMulti
                                                                                                        isDisabled={!row?.frequency}
                                                                                                        className={`${errors.months ? "is-invalid" : ""}`}
                                                                                                        options={monthDataOptions}
                                                                                                        value={
                                                                                                            row?.months?.length > 0
                                                                                                                ? row.months.split(',').map(id => monthDataOptions.find(option => option.value === id))
                                                                                                                : [] // Return an empty array if `row?.months` is not a valid string
                                                                                                        }
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="age_criteria"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Age Criteria
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="age_criteria"
                                                                                                        name="age_criteria"
                                                                                                        placeholder="Enter age"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.slabAgeCriteria}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "slabAgeCriteria",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.months}
                                                                                                        className={`form-control w-100 ${errors?.slabAgeCriteria ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="age_limit_exceed"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Age limit exceed
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="age_limit_exceed"
                                                                                                        name="age_limit_exceed"
                                                                                                        placeholder="Enter age"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.slabAgeExceed}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "slabAgeExceed",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.slabAgeCriteria}
                                                                                                        className={`form-control w-100 ${errors?.slabAgeExceed ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                            <td >
                                                                                                <div style={{ "width": "8rem" }} className="form-check  form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="min_cap"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Min Cap
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="min_cap"
                                                                                                        name="min_cap"
                                                                                                        placeholder="Enter min slab"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.minCap}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "minCap",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.slabAgeExceed}
                                                                                                        className={`form-control w-100 ${errors?.minCap ? "is-invalid" : ""}`}
                                                                                                    />

                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div style={{ "width": "8rem" }} className="form-check form-check-inline">
                                                                                                    <label
                                                                                                        htmlFor="max_cap"
                                                                                                        className="form-check-label"
                                                                                                    >
                                                                                                        Max Cap
                                                                                                    </label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="max_cap"
                                                                                                        name="max_cap"
                                                                                                        placeholder="Enter max slab"
                                                                                                        // ref={headAgeNumberRef}
                                                                                                        value={row?.maxCap}
                                                                                                        onChange={(e) =>
                                                                                                            handleSlabChange(
                                                                                                                idx,
                                                                                                                "maxCap",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={!row?.earnedSlabMin}
                                                                                                        className={`form-control w-100 ${errors?.maxCap ? "is-invalid" : ""}`}
                                                                                                    />
                                                                                                </div>
                                                                                               
                                                                                            </td>
                                                                                        </tr>
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        <div className=" text-danger">{errors?.headTitleForPayslip ? errors?.headTitleForPayslip : null}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                </div> */}
                                                {/*  Show this head in onboarding CTC structure */}
                                                <div ref={onboardingCtcRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Show this head in onboarding CTC structure</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="onboardingCtc_yes"
                                                            name="onboardingCtc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.onboardingCtc === "1"}
                                                            onChange={() =>
                                                                handleChange("onboardingCtc", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="onboardingCtc_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="onboardingCtc_no"
                                                            name="onboardingCtc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.onboardingCtc === "0"}
                                                            onChange={() =>
                                                                handleChange("onboardingCtc", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="onboardingCtc_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    
                                                   
                                                </div>
                                                {/*  Show this head in other earnings file */}
                                                {(formData?.payrollHeadType === "Other Earnings" || formData?.payrollHeadType === "Other Deductions") &&(
                                                <div ref={otherEarningsRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this head use in other earning/deduction excel import?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="otherEarnings_yes"
                                                            name="otherEarnings"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.otherEarnings === "1"}
                                                            onChange={() =>
                                                                handleChange("otherEarnings", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="otherEarnings_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="otherEarnings_no"
                                                            name="otherEarnings"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.otherEarnings === "0"}
                                                            onChange={() =>
                                                                handleChange("otherEarnings", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="otherEarnings_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.otherEarnings ? errors?.otherEarnings : null}</div>
                                                </div>)}
            
                                                {/* Show this head in attendance file */}
                                                {/* <div ref={otherEarningsInAttendanceRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Show this head in attendance file?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="otherEarningsInAttendance_yes"
                                                            name="otherEarningsInAttendance"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.otherEarningsInAttendance === "1"}
                                                            onChange={() =>
                                                                handleChange("otherEarningsInAttendance", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="otherEarningsInAttendance_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="otherEarningsInAttendance_no"
                                                            name="otherEarningsInAttendance"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.otherEarningsInAttendance === "0"}
                                                            onChange={() =>
                                                                handleChange("otherEarningsInAttendance", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="otherEarningsInAttendance_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                   
                                                </div> */}
                                                 {/*  Should this head value to be Round Up / Round Down / Round / As It Is*/}
                                                 <div ref={headValueToBeRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Should this head value to be?</label>
                                                    </div>
                                                    <div onClick={() =>
                                                        handleChange("headValueToBe", "1")}
                                                        className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_Value_To_Be_Round_UP"
                                                            name="head_Value_To_Be"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="Round Up"
                                                            checked={formData?.headValueToBe === "1"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_Value_To_Be_Round_UP"
                                                            className="form-check-label"
                                                        >
                                                            Round Up
                                                        </label>
                                                    </div> <br />
                                                    
                                                    <div onClick={() =>
                                                        handleChange("headValueToBe", "2")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_Value_To_Be_Round_Down"
                                                            name="head_Value_To_Be"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="2"
                                                            checked={formData?.headValueToBe === "2"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_Value_To_Be_Round_Down"
                                                            className="form-check-label"
                                                        >
                                                            Round Down
                                                        </label>
                                                    </div> <br />
                                                   
                                                    <div onClick={() =>
                                                        handleChange("headValueToBe", "3")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_Value_To_Be_Round"
                                                            name="head_Value_To_Be"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="3"
                                                            checked={formData?.headValueToBe === "3"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_Value_To_Be_Round "
                                                            className="form-check-label"
                                                        >
                                                           Round
                                                        </label>
                                                    </div> <br />
                                                   
                                                    <div onClick={() =>
                                                        handleChange("headValueToBe", "4")
                                                    } className="form-check mt-3 form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="head_Value_To_Be_As_It_Is"
                                                            name="head_Value_To_Be"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="4"
                                                            checked={formData?.headValueToBe === "4"}

                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="head_Value_To_Be_As_It_Is"
                                                            className="form-check-label"
                                                        >
                                                            As It Is
                                                        </label>
                                                    </div> <br />
                                                   
                                                    
                                                    <div className=" text-danger">{errors?.headValueToBe ? errors?.headValueToBe : null}</div>
                                                </div>
                                                {/*  Does this component considered as Default Salary Head? */}
                                                <div ref={monthlyGrossRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this component considered as Default Salary Head?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyGross_yes"
                                                            name="monthlyGross"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.monthlyGross === "1"}
                                                            onChange={() =>
                                                                handleChange("monthlyGross", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyGross_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyGross_no"
                                                            name="monthlyGross"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.monthlyGross === "0"}
                                                            onChange={() =>
                                                                handleChange("monthlyGross", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyGross_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.monthlyGross ? errors?.monthlyGross : null}</div>
                                                    {formData?.monthlyGross === "1" && (
                                                        <>
                                                            <div ref={monthlyGrossTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyGrossType12"
                                                                        name="monthlyGrossType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.monthlyGrossType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyGrossType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyGrossType12"
                                                                        className="form-check-label"
                                                                    >
                                                                        Fixed Default Salary Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyGrossType2"
                                                                        name="monthlyGrossType"


                                                                        value={"2"}
                                                                        checked={formData?.monthlyGrossType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyGrossType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyGrossType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Earned Default Salary Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyGrossType3"
                                                                        name="monthlyGrossType"


                                                                        value={"3"}
                                                                        checked={formData?.monthlyGrossType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyGrossType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyGrossType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Arrear Default Salary Head
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.monthlyGrossType ? errors?.monthlyGrossType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                                                        {/*  Is this part of EE Statutory Deducations? */}
                                                        <div ref={eeStatutoryDeductionRef} className="">
                                                            <div>
                                                                <label> Is this part of EE Statutory Deducations?</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="eeStatutoryDeduction_yes"
                                                                    name="eeStatutoryDeduction"
                                                                    // disabled={!formData?.visibleHeadInPayslip}
                                                                    value="1"
                                                                    checked={formData?.eeStatutoryDeduction === "1"}
                                                                    onChange={() =>
                                                                        handleChange("eeStatutoryDeduction", "1")
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor="eeStatutoryDeduction_yes"
                                                                    className="form-check-label"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="eeStatutoryDeduction_no"
                                                                    name="eeStatutoryDeduction"
                                                                    // disabled={!formData?.visibleHeadInPayslip}
                                                                    value="0"
                                                                    checked={formData?.eeStatutoryDeduction === "0"}
                                                                    onChange={() =>
                                                                        handleChange("eeStatutoryDeduction", "0")
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor="eeStatutoryDeduction_no"
                                                                    className="form-check-label"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                            <div className=" text-danger">{errors?.eeStatutoryDeduction ? errors?.eeStatutoryDeduction : null}</div>
                                                            {formData?.eeStatutoryDeduction === "1" && (
                                                                <>
                                                                    <div ref={eeStatutoryDeductionTypeRef} className="mx-4 ">

                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="eeStatutoryDeductionType1"
                                                                                name="eeStatutoryDeductionType"

                                                                                // ref={headTitleForPayslipRef}
                                                                                value={"1"}
                                                                                checked={formData?.eeStatutoryDeductionType === "1"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "eeStatutoryDeductionType",
                                                                                        "1"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input `}
                                                                            />
                                                                            <label
                                                                                htmlFor="eeStatutoryDeductionType1"
                                                                                className="form-check-label"
                                                                            >
                                                                                EE Statutory Deductions on Fixed Head
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mx-4  ">

                                                                        <div className="form-check form-check-inline ">
                                                                            <input
                                                                                type="radio"
                                                                                id="eeStatutoryDeductionType2"
                                                                                name="eeStatutoryDeductionType"


                                                                                value={"2"}
                                                                                checked={formData?.eeStatutoryDeductionType === "2"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "eeStatutoryDeductionType",
                                                                                        "2"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input`}
                                                                            />
                                                                            <label
                                                                                htmlFor="eeStatutoryDeductionType2"
                                                                                className="form-check-label"
                                                                            >
                                                                                EE Statutory Deductions on Earned Head
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mx-4  ">

                                                                        <div className="form-check form-check-inline ">
                                                                            <input
                                                                                type="radio"
                                                                                id="eeStatutoryDeductionType3"
                                                                                name="eeStatutoryDeductionType"


                                                                                value={"3"}
                                                                                checked={formData?.eeStatutoryDeductionType === "3"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "eeStatutoryDeductionType",
                                                                                        "3"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input`}
                                                                            />
                                                                            <label
                                                                                htmlFor="eeStatutoryDeductionType3"
                                                                                className="form-check-label"
                                                                            >
                                                                                EE Statutory Deductions on Arrear Head
                                                                            </label>
                                                                        </div>
                                                                        <div className=" text-danger">{errors?.eeStatutoryDeductionType ? errors?.eeStatutoryDeductionType : null}</div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        {/*  Is this part of ER Statutory Contribution? */}
                                                        <div ref={erStatutoryContributionRef} className="">
                                                            <div>
                                                                <label>Is this part of ER Statutory Contributions?</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="erStatutoryContribution_yes"
                                                                    name="erStatutoryContribution"
                                                                    // disabled={!formData?.visibleHeadInPayslip}
                                                                    value="1"
                                                                    checked={formData?.erStatutoryContribution === "1"}
                                                                    onChange={() =>
                                                                        handleChange("erStatutoryContribution", "1")
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor="erStatutoryContribution_yes"
                                                                    className="form-check-label"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="erStatutoryContribution_no"
                                                                    name="erStatutoryContribution"
                                                                    // disabled={!formData?.visibleHeadInPayslip}
                                                                    value="0"
                                                                    checked={formData?.erStatutoryContribution === "0"}
                                                                    onChange={() =>
                                                                        handleChange("erStatutoryContribution", "0")
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor="erStatutoryContribution_no"
                                                                    className="form-check-label"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                            <div className=" text-danger">{errors?.erStatutoryContribution ? errors?.erStatutory : null}</div>
                                                            {formData?.erStatutoryContribution === "1" && (
                                                                <>
                                                                    <div ref={erStatutoryContributionTypeRef} className="mx-4 ">

                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="erStatutoryContributionType1"
                                                                                name="erStatutoryContributionType"

                                                                                // ref={headTitleForPayslipRef}
                                                                                value={"1"}
                                                                                checked={formData?.erStatutoryContributionType === "1"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "erStatutoryContributionType",
                                                                                        "1"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input `}
                                                                            />
                                                                            <label
                                                                                htmlFor="erStatutoryContributionType1"
                                                                                className="form-check-label"
                                                                            >
                                                                                ER Statutory Contributions on Fixed Head
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mx-4  ">

                                                                        <div className="form-check form-check-inline ">
                                                                            <input
                                                                                type="radio"
                                                                                id="erStatutoryContributionType2"
                                                                                name="erStatutoryContributionType"


                                                                                value={"2"}
                                                                                checked={formData?.erStatutoryContributionType === "2"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "erStatutoryContributionType",
                                                                                        "2"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input`}
                                                                            />
                                                                            <label
                                                                                htmlFor="erStatutoryContributionType2"
                                                                                className="form-check-label"
                                                                            >
                                                                                ER Statutory Contributions on Earned Head
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mx-4  ">

                                                                        <div className="form-check form-check-inline ">
                                                                            <input
                                                                                type="radio"
                                                                                id="erStatutoryContributionType3"
                                                                                name="erStatutoryContributionType"


                                                                                value={"3"}
                                                                                checked={formData?.erStatutoryContributionType === "3"}
                                                                                onChange={(e) =>
                                                                                    handleChange(
                                                                                        "erStatutoryContributionType",
                                                                                        "3"
                                                                                    )
                                                                                }
                                                                                className={`form-check-input`}
                                                                            />
                                                                            <label
                                                                                htmlFor="erStatutoryContributionType3"
                                                                                className="form-check-label"
                                                                            >
                                                                                ER Statutory Contributions on Arrear Head
                                                                            </label>
                                                                        </div>
                                                                        <div className=" text-danger">{errors?.erStatutoryContributionType ? errors?.erStatutoryContributionType : null}</div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/*  Is this part of Other Earnings? */}
                                                <div ref={monthlyOtherEarningsRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is this part of Other Earnings?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyOtherEarnings_yes"
                                                            name="monthlyOtherEarnings"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.monthlyOtherEarnings === "1"}
                                                            onChange={() =>
                                                                handleChange("monthlyOtherEarnings", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyOtherEarnings_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyOtherEarnings_no"
                                                            name="monthlyOtherEarnings"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.monthlyOtherEarnings === "0"}
                                                            onChange={() =>
                                                                handleChange("monthlyOtherEarnings", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyOtherEarnings_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.monthlyOtherEarnings ? errors?.monthlyOtherEarnings : null}</div>
                                                    {formData?.monthlyOtherEarnings === "1" && (
                                                        <>
                                                            <div ref={monthlyOtherEarningsTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyOtherEarningsType1"
                                                                        name="monthlyOtherEarningsType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.monthlyOtherEarningsType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyOtherEarningsType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyOtherEarningsType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Earnings on Fixed Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyOtherEarningsType2"
                                                                        name="monthlyOtherEarningsType"


                                                                        value={"2"}
                                                                        checked={formData?.monthlyOtherEarningsType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyOtherEarningsType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyOtherEarningsType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Earnings on Earned Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyOtherEarningsType3"
                                                                        name="monthlyOtherEarningsType"


                                                                        value={"3"}
                                                                        checked={formData?.monthlyOtherEarningsType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyOtherEarningsType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyOtherEarningsType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Earnings on Arrear Head
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.monthlyOtherEarningsType ? errors?.monthlyOtherEarningsType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {/*  Does this component considered as Arrear Head? */}
                                                <div ref={consideredArrearHeadRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this component considered as Arrear Head?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="consideredArrearHead_yes"
                                                            name="consideredArrearHead"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.consideredArrearHead === "1"}
                                                            onChange={() =>
                                                                handleChange("consideredArrearHead", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="consideredArrearHead_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="consideredArrearHead_no"
                                                            name="consideredArrearHead"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.consideredArrearHead === "0"}
                                                            onChange={() =>
                                                                handleChange("consideredArrearHead", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="consideredArrearHead_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.consideredArrearHead ? errors?.consideredArrearHead : null}</div>
                                                </div>
                                               
                                                {/* part of monthly ctc */}
                                                {/* <div ref={isPartOfMonthlyCtcRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is this part of monthly CTC</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_part_of_monthly_ctc_yes"
                                                            name="is_part_of_monthly_ctc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isPartOfMonthlyCtc === "1"}
                                                            onChange={() =>
                                                                handleChange("isPartOfMonthlyCtc", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_part_of_monthly_ctc_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_part_of_monthly_ctc_no"
                                                            name="is_part_of_monthly_ctc"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isPartOfMonthlyCtc === "0"}
                                                            onChange={() =>
                                                                handleChange("isPartOfMonthlyCtc", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_part_of_monthly_ctc_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isPartOfMonthlyCtc ? errors?.isPartOfMonthlyCtc : null}</div>
                                                    {formData?.isPartOfMonthlyCtc === "1" && (
                                                        <>
                                                            <div ref={isPartOfMonthlyCtcTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="isPartOfMonthlyCtcType1"
                                                                        name="isPartOfMonthlyCtcType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.isPartOfMonthlyCtcType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isPartOfMonthlyCtcType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="isPartOfMonthlyCtcType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Fixed Monthly CTC
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="isPartOfMonthlyCtcType2"
                                                                        name="isPartOfMonthlyCtcType"


                                                                        value={"2"}
                                                                        checked={formData?.isPartOfMonthlyCtcType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isPartOfMonthlyCtcType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="isPartOfMonthlyCtcType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Earned Monthly CTC
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="isPartOfMonthlyCtcType3"
                                                                        name="isPartOfMonthlyCtcType"


                                                                        value={"3"}
                                                                        checked={formData?.isPartOfMonthlyCtcType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isPartOfMonthlyCtcType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="isPartOfMonthlyCtcType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Arrear Monthly CTC
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.isPartOfMonthlyCtcType ? errors?.isPartOfMonthlyCtcType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div> */}
                                                {/*  Is a Part of Total Monthly Deductions? */}
                                                <div ref={monthlyDeductionRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is a Part of Total Monthly Deductions?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyDeduction_yes"
                                                            name="monthlyDeduction"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.monthlyDeduction === "1"}
                                                            onChange={() =>
                                                                handleChange("monthlyDeduction", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyDeduction_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlyDeduction_no"
                                                            name="monthlyDeduction"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.monthlyDeduction === "0"}
                                                            onChange={() =>
                                                                handleChange("monthlyDeduction", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlyDeduction_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.monthlyDeduction ? errors?.monthlyDeduction : null}</div>
                                                    {formData?.monthlyDeduction === "1" && (
                                                        <>
                                                            <div ref={monthlyDeductionTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyDeductionType1"
                                                                        name="monthlyDeductionType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.monthlyDeductionType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyDeductionType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyDeductionType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Deductions on Fixed Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyDeductionType2"
                                                                        name="monthlyDeductionType"


                                                                        value={"2"}
                                                                        checked={formData?.monthlyDeductionType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyDeductionType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyDeductionType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Deductions on Earned Head
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlyDeductionType3"
                                                                        name="monthlyDeductionType"


                                                                        value={"3"}
                                                                        checked={formData?.monthlyDeductionType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlyDeductionType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlyDeductionType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Other Deductions on Arrear Head
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.monthlyDeductionType ? errors?.monthlyDeductionType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {/* Does this component is Non-Monthly Payout  */}
                                                <div ref={isStatutoryRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Does this component is Non-Monthly Payout?  </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_component_statutory_yes"
                                                            name="is_component_statutory"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isStatutory === "1"}
                                                            onChange={() =>
                                                                handleChange("isStatutory", "1")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_component_statutory_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_component_statutory_no"
                                                            name="is_component_statutory"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isStatutory === "0"}
                                                            onChange={() =>
                                                                handleChange("isStatutory", "0")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_component_statutory_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isStatutory ? errors?.isStatutory : null}</div>
                                                    {formData?.isStatutory === "1" && (
                                                        <>
                                                            <div ref={isStatutoryTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="isStatutoryType1"
                                                                        name="isStatutoryType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.isStatutoryType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isStatutoryType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="isStatutoryType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Fixed Yearly Payout
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="isStatutoryType2"
                                                                        name="isStatutoryType"


                                                                        value={"2"}
                                                                        checked={formData?.isStatutoryType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isStatutoryType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="isStatutoryType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Earned Yearly Payout
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="isStatutoryType3"
                                                                        name="isStatutoryType"


                                                                        value={"3"}
                                                                        checked={formData?.isStatutoryType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isStatutoryType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="isStatutoryType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Arrear Yearly Payout
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.isStatutoryType ? errors?.isStatutoryType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {/* Does this component used for the calculation of Ex Gratia  */}
                                                <div ref={isExGratiaRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Does this component used for the calculation of Ex Gratia?  </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_Ex_Gratia_yes"
                                                            name="is_Ex_Gratia"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isExGratia === "1"}
                                                            onChange={() =>
                                                                handleChange("isExGratia", "1")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_Ex_Gratia_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_Ex_Gratia_no"
                                                            name="is_Ex_Gratia"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isExGratia === "0"}
                                                            onChange={() =>
                                                                handleChange("isExGratia", "0")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_Ex_Gratia_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isExGratia ? errors?.isExGratia : null}</div>

                                                </div>
                                                {/* Does this component is used for calculation of Gratuity */}
                                                <div ref={isGratuityRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Does this component is used for calculation of Gratuity?  </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_component_gratuity_yes"
                                                            name="is_component_gratuity"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isGratuity === "1"}
                                                            onChange={() =>
                                                                handleChange("isGratuity", "1")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_component_gratuity_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_component_gratuity_no"
                                                            name="is_component_gratuity"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isGratuity === "0"}
                                                            onChange={() =>
                                                                handleChange("isGratuity", "0")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="is_component_gratuity_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isGratuity ? errors?.isGratuity : null}</div>

                                                </div>
                                                {/* Does this component have any effect on Net Pay  */}
                                                {/* <div ref={effectOnNetPayRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this component have any effect on monthly Net Pay?  </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="effect_on_net_pay_yes"
                                                            name="effect_on_net_pay"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.effectOnNetPay === "1"}
                                                            onChange={() =>
                                                                handleChange("effectOnNetPay", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="effect_on_net_pay_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="effect_on_net_pay_no"
                                                            name="effect_on_net_pay"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.effectOnNetPay === "0"}
                                                            onChange={() =>
                                                                handleChange("effectOnNetPay", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="effect_on_net_pay_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.effectOnNetPay ? errors?.effectOnNetPay : null}</div>
                                                    {formData?.effectOnNetPay === "1" && (
                                                        <>
                                                            <div ref={effectOnNetPayTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="effectOnNetPayType1"
                                                                        name="effectOnNetPayType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.effectOnNetPayType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "effectOnNetPayType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="effectOnNetPayType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Fixed Monthly Net Pay
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="effectOnNetPayType2"
                                                                        name="effectOnNetPayType"


                                                                        value={"2"}
                                                                        checked={formData?.effectOnNetPayType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "effectOnNetPayType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="effectOnNetPayType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Earned Monthly Net Pay
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="effectOnNetPayType3"
                                                                        name="effectOnNetPayType"


                                                                        value={"3"}
                                                                        checked={formData?.effectOnNetPayType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "effectOnNetPayType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="effectOnNetPayType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Arrear Monthly Net Pay
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.effectOnNetPayType ? errors?.effectOnNetPayType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div> */}
                                                {/* Does this Component is used for calculation of Leave Encashment */}
                                                <div ref={componentLeaveEncashmentRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this Component is used for calculation of Leave Encashment?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="component_leave_encashment_yes"
                                                            name="component_leave_encashment"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.componentLeaveEncashment === "1"}
                                                            onChange={() =>
                                                                handleChange("componentLeaveEncashment", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="component_leave_encashment_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="component_leave_encashment_no"
                                                            name="component_leave_encashment"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.componentLeaveEncashment === "0"}
                                                            onChange={() =>
                                                                handleChange("componentLeaveEncashment", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="component_leave_encashment_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.componentLeaveEncashment ? errors?.componentLeaveEncashment : null}</div>
                                                    {formData?.componentLeaveEncashment === "1" && (
                                                        <div ref={leavesToBeEncashedRef}  className="mx-4">
                                                            <label htmlFor="leavesToBeEncashed" className="form-check-label">
                                                                Select Leaves To Be Encashed
                                                            </label>
                                                            <Select
                                                                onChange={(selectedOptions) => handleMultiSelect("leavesToBeEncashed", selectedOptions)}
                                                                placeholder="Select Leaves"
                                                                isMulti
                                                                // className={`${errors.leavesToBeEncashed ? "is-invalid" : ""}`}
                                                                options={leaveOptions}
                                                                value={formData.leavesToBeEncashed ? formData.leavesToBeEncashed.split(',').map(id => leaveOptions.find(option => option.value == id)) : null}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Min. Capping for the Calculated Amount */}
                                                <div ref={isMinCappingRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do you have Min. Capping for the Calculated
                                                            Amount?  </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_min_cap_yes"
                                                            name="is_min_cap"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isMinCapping === "1"}
                                                            onChange={() =>
                                                                handleChange("isMinCapping", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_min_cap_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_min_cap_no"
                                                            name="is_min_cap"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isMinCapping === "0"}
                                                            onChange={() =>
                                                                handleChange("isMinCapping", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_min_cap_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isMinCapping ? errors?.isMinCapping : null}</div>
                                                    {formData?.isMinCapping === "1" && (
                                                        <div ref={isMinCappingInputRef} className="mx-4 ">
                                                            <div>
                                                                <label>
                                                                    Min. Capping
                                                                </label>
                                                            </div>
                                                            <div className="w-100 ">
                                                                <input
                                                                    type="number"
                                                                    id="isMinCappingInput"
                                                                    name="isMinCappingInput"
                                                                    placeholder="Enter Min Cap"
                                                                    // ref={headAgeNumberRef}
                                                                    value={formData?.isMinCappingInput}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            "isMinCappingInput",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.isMinCappingInput ? "is-invalid" : ""}`}
                                                                />
                                                                {/* <label htmlFor="isMinCappingInputInput" className="form-check-label">Yes</label> */}
                                                            </div>
                                                            {/* <div className=" text-danger">{errors?.isMinCappingInput ? errors?.isMinCappingInput : null}</div> */}
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Max Capping for the Calculated Amount */}
                                                <div ref={isMaxCappingRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do You have any Max Capping for the Calculated
                                                            Amount? </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_max_cap_yes"
                                                            name="is_max_cap"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.isMaxCapping === "1"}
                                                            onChange={() =>
                                                                handleChange("isMaxCapping", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_max_cap_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="is_max_cap_no"
                                                            name="is_max_cap"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.isMaxCapping === "0"}
                                                            onChange={() =>
                                                                handleChange("isMaxCapping", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="is_max_cap_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.isMaxCapping ? errors?.isMaxCapping : null}</div>
                                                    {formData?.isMaxCapping === "1" && (
                                                        <>
                                                            <div ref={isMaxCappingInputRef} className="mx-4 ">
                                                                <div>
                                                                    <label>
                                                                        Max Capping
                                                                    </label>
                                                                </div>
                                                                <div className="w-100 ">
                                                                    <input
                                                                        type="number"
                                                                        id="isMaxCappingInput"
                                                                        name="isMaxCappingInput"
                                                                        placeholder="Enter Max Cap"
                                                                        // ref={headAgeNumberRef}
                                                                        value={formData?.isMaxCappingInput}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "isMaxCappingInput",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        className={`form-control w-100 ${errors?.isMaxCappingInput ? "is-invalid" : ""}`}
                                                                    />
                                                                </div>

                                                            </div>
                                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }} className="mx-4 ">
                                                            <div ref={isMaxCappingHeadSumRef} >
                                                                <label>Sum(+)</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("isMaxCappingHeadSum", selectedOptions)}
                                                                    placeholder="Select Head"
                                                                    isMulti
                                                                    // className={`${errors.isMaxCappingHeadSum ? "is-invalid" : ""}`}
                                                                    options={rows}
                                                                    value={formData.isMaxCappingHeadSum ? formData.isMaxCappingHeadSum.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                />
                                                                {/* {errors.isMaxCappingHeadSum && <div className="text-danger">{errors.isMaxCappingHeadSum}</div>} */}
                                                            </div>
                                                            <div ref={isMaxCappingHeadSubRef}>
                                                                <label>Sub(-)</label>
                                                                <Select
                                                                    onChange={(selectedOptions) => handleMultiSelect("isMaxCappingHeadSub", selectedOptions)}
                                                                    placeholder="Select Head"
                                                                    isMulti
                                                                    // className={`${errors.subOfHead ? "is-invalid" : ""}`}
                                                                    options={rows}
                                                                    value={formData.isMaxCappingHeadSub ? formData.isMaxCappingHeadSub.split(',').map(id => rows.find(option => option.value == id)) : null}
                                                                />
                                                                {/* {errors.isMaxCappingHeadSub && <div className="text-danger">{errors.isMaxCappingHeadSub}</div>} */}
                                                            </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {/*  is a Part of “Monthly Salary Register? */}
                                                <div ref={monthlySalaryRegisterRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is a Part of Monthly Salary Register?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlySalaryRegister_yes"
                                                            name="monthlySalaryRegister"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.monthlySalaryRegister === "1"}
                                                            onChange={() =>
                                                                handleChange("monthlySalaryRegister", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlySalaryRegister_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="monthlySalaryRegister_no"
                                                            name="monthlySalaryRegister"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.monthlySalaryRegister === "0"}
                                                            onChange={() =>
                                                                handleChange("monthlySalaryRegister", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="monthlySalaryRegister_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.monthlySalaryRegister ? errors?.monthlySalaryRegister : null}</div>
                                                    {formData?.monthlySalaryRegister === "1" && (
                                                        <>
                                                            <div ref={monthlySalaryRegisterTypeRef} className="mx-4 ">

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlySalaryRegisterType1"
                                                                        name="monthlySalaryRegisterType"

                                                                        // ref={headTitleForPayslipRef}
                                                                        value={"1"}
                                                                        checked={formData?.monthlySalaryRegisterType === "1"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlySalaryRegisterType",
                                                                                "1"
                                                                            )
                                                                        }
                                                                        className={`form-check-input `}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlySalaryRegisterType1"
                                                                        className="form-check-label"
                                                                    >
                                                                        Fixed Monthly Salary Register
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlySalaryRegisterType2"
                                                                        name="monthlySalaryRegisterType"


                                                                        value={"2"}
                                                                        checked={formData?.monthlySalaryRegisterType === "2"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlySalaryRegisterType",
                                                                                "2"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlySalaryRegisterType2"
                                                                        className="form-check-label"
                                                                    >
                                                                        Earned Monthly Salary Register
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="mx-4  ">

                                                                <div className="form-check form-check-inline ">
                                                                    <input
                                                                        type="radio"
                                                                        id="monthlySalaryRegisterType3"
                                                                        name="monthlySalaryRegisterType"


                                                                        value={"3"}
                                                                        checked={formData?.monthlySalaryRegisterType === "3"}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                "monthlySalaryRegisterType",
                                                                                "3"
                                                                            )
                                                                        }
                                                                        className={`form-check-input`}
                                                                    />
                                                                    <label
                                                                        htmlFor="monthlySalaryRegisterType3"
                                                                        className="form-check-label"
                                                                    >
                                                                        Arrear Monthly Salary Register
                                                                    </label>
                                                                </div>
                                                                <div className=" text-danger">{errors?.monthlySalaryRegisterType ? errors?.monthlySalaryRegisterType : null}</div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {/* Does this Component have State wise Criteria? */}
                                                {/* <div ref={componentStateWiseCriteriaRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Does this Component have State wise Criteria?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="component_state_wise_criteria_yes"
                                                            name="component_state_wise_criteria"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.componentStateWiseCriteria === "1"}
                                                            onChange={() =>
                                                                handleChange("componentStateWiseCriteria", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="component_state_wise_criteria_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="component_state_wise_criteria_no"
                                                            name="component_state_wise_criteria"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.componentStateWiseCriteria === "0"}
                                                            onChange={() =>
                                                                handleChange("componentStateWiseCriteria", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="component_state_wise_criteria_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.componentStateWiseCriteria ? errors?.componentStateWiseCriteria : null}</div>

                                                </div> */}
                                                {/* Does this Component depend on Individual Employee Selection? */}
                                                {/* <div ref={dependsOnIndividualEmployeeRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Does this Component depend on Individual Employee Selection?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="dependsOnIndividualEmployee_yes"
                                                            name="dependsOnIndividualEmployee"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="1"
                                                            checked={formData?.dependsOnIndividualEmployee === "1"}
                                                            onChange={() =>
                                                                handleChange("dependsOnIndividualEmployee", "1")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="dependsOnIndividualEmployee_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="dependsOnIndividualEmployee_no"
                                                            name="dependsOnIndividualEmployee"
                                                            // disabled={!formData?.visibleHeadInPayslip}
                                                            value="0"
                                                            checked={formData?.dependsOnIndividualEmployee === "0"}
                                                            onChange={() =>
                                                                handleChange("dependsOnIndividualEmployee", "0")
                                                            }
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor="dependsOnIndividualEmployee_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger">{errors?.dependsOnIndividualEmployee ? errors?.dependsOnIndividualEmployee : null}</div>

                                                </div> */}
                                                {/* Create - "Earned Component for this Fixed Head"? */}
                                                {formData?.payrollHeadType === "Fixed Component" && (
                                                    <div ref={isCreateEarnedHeadRef} className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label>Create Earned Component for this Fixed Head?</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isCreateEarnedHead_yes"
                                                                name="isCreateEarnedHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="1"
                                                                checked={formData?.isCreateEarnedHead === "1"}
                                                                onChange={() =>
                                                                    handleChange("isCreateEarnedHead", "1")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isCreateEarnedHead_yes"
                                                                className="form-check-label"
                                                            >
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="isCreateEarnedHead_no"
                                                                name="isCreateEarnedHead"
                                                                // disabled={!formData?.visibleHeadInPayslip}
                                                                value="0"
                                                                checked={formData?.isCreateEarnedHead === "0"}
                                                                onChange={() =>
                                                                    handleChange("isCreateEarnedHead", "0")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="isCreateEarnedHead_no"
                                                                className="form-check-label"
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                        <div className=" text-danger">{errors?.isCreateEarnedHead ? errors?.isCreateEarnedHead : null}</div>

                                                    </div>
                                                )}

                                                {/* success message */}
                                                <div style={{ width: "60%", margin: "auto" }}>
                                                    {successMsg ?
                                                        <div className=" position-relative alert alert-success mt-3" role="alert">
                                                            {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                        </div>
                                                        : null
                                                    }
                                                    {/* error message */}
                                                    {errorMsg ?
                                                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                            {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                        </div> : null
                                                    }
                                                </div>
                                            </form>
                                            {/* save or update button */}
                                            <div style={{ marginTop: "30px", marginLeft: "Auto" }}>
                                                {/* <button
                                                    disabled={loading}
                                                    type="submit"
                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                >
                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                    {company_salary_head_id ? "Update" : "Save"}
                                                </button> */}
                                                <SubmitButton
                                                onClick={(e)=> handleSubmit(e)}
                                                loading={loading}
                                                loadingMessage='loading' buttonName={company_salary_head_id ? "Update" : "Save"} icon={'ri-save-line'} 
                                                type='primary' iconSide='left' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "90vh" }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PayrollHeadCreate;
